require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/0328c89a9d01ef29be48a47d8e3162dc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0328c89a9d01ef29be48a47d8e3162dc'] = async function fn_0328c89a9d01ef29be48a47d8e3162dc(year, invoices, expenses) {
var invoicesMonthsList, expensesMonthsList, invoicePrice, invoiceItem, invoice, month, currentYearInvoices, expensePrice, expense, currentYearExpenses;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  currentYearInvoices = (await asyncListFilter(invoices, async (invoice) => {


   return ((new Date((getObjectProperty(invoice, 'issuedDate'))).getFullYear()) == year);
  }));
  currentYearExpenses = (await asyncListFilter(expenses, async (expense) => {


   return ((new Date((getObjectProperty(expense, 'expenseDate'))).getFullYear()) == year);
  }));
  expensesMonthsList = [];
  invoicesMonthsList = [];
  for (month = 1; month <= 12; month++) {
    expensePrice = 0;
    for (var expense_index in currentYearExpenses) {
      expense = currentYearExpenses[expense_index];
      if ((new Date((getObjectProperty(expense, 'expenseDate'))).getMonth() + 1) == month) {
        expensePrice = expensePrice + (getObjectProperty(expense, 'price'));
      }
    }
    addItemToList(expensesMonthsList, expensePrice);
    invoicePrice = 0;
    for (var invoice_index in currentYearInvoices) {
      invoice = currentYearInvoices[invoice_index];
      if ((new Date((getObjectProperty(invoice, 'issuedDate'))).getMonth() + 1) == month && 'paid' == (getObjectProperty((getObjectProperty(invoice, 'status')), 'name')).toLowerCase().trim()) {
        var invoiceItem_list = (getObjectProperty(invoice, 'invoiceItems'));
        for (var invoiceItem_index in invoiceItem_list) {
          invoiceItem = invoiceItem_list[invoiceItem_index];
          invoicePrice = invoicePrice + (getObjectProperty(invoiceItem, 'unitPrice')) * (getObjectProperty(invoiceItem, 'quantity')) + (getObjectProperty(invoiceItem, 'unitPrice')) * (getObjectProperty(invoiceItem, 'quantity')) * ((getObjectProperty(invoiceItem, 'tax')) / 100);
        }
      }
    }
    addItemToList(invoicesMonthsList, invoicePrice);
  }

return ({ 'expenses': expensesMonthsList,'invoices': invoicesMonthsList })
}

})
define('./functions/1bdd050bbb88befbadc32c79892f5a12/code.js', () => { 

var j, firstCharAvatar, firstCharLastName, firstCharFirstName;



BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12'] = async function fn_1bdd050bbb88befbadc32c79892f5a12(listOfObjects, people, propertyForAvatar) {
    for (var j_index in listOfObjects) {
    j = listOfObjects[j_index];
    if (!(j['image'])) {
      if (people) {
        if (j['lastName']) {
          firstCharLastName = (j['lastName']).charAt(0);
        } else {
          firstCharLastName = '';
        }
        if (j['firstName']) {
          firstCharFirstName = (j['firstName']).charAt(0);
        } else {
          firstCharFirstName = '';
        }
        j['avatarContent'] = (String(firstCharLastName) + String(firstCharFirstName));
        firstCharAvatar = firstCharLastName;
      } else {
        j['avatarContent'] = ((j[propertyForAvatar]).charAt(0));
        firstCharAvatar = (j[propertyForAvatar]).charAt(0);
      }
      j['avatar'] = true;
      if (firstCharAvatar.toUpperCase() >= 'A' && firstCharAvatar.toUpperCase() <= 'F') {
        j['avatarBgColor'] = '#8a2be2';
      }
      if (firstCharAvatar.toUpperCase() >= 'G' && firstCharAvatar.toUpperCase() <= 'K') {
        j['avatarBgColor'] = '#008000';
      }
      if (firstCharAvatar.toUpperCase() >= 'L' && firstCharAvatar.toUpperCase() <= 'P') {
        j['avatarBgColor'] = '#ff0000';
      }
      if (firstCharAvatar.toUpperCase() >= 'Q' && firstCharAvatar.toUpperCase() <= 'U') {
        j['avatarBgColor'] = '#ffa500';
      }
      if (firstCharAvatar.toUpperCase() >= 'V' && firstCharAvatar.toUpperCase() <= 'Z') {
        j['avatarBgColor'] = '#808080';
      }
    } else {
      j['avatar'] = false;
    }
  }


  return listOfObjects
}

})
define('./functions/28a25e1f0a29acc69de74219ea997b8b/code.js', () => { 

var result, error;



BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b'] = async function fn_28a25e1f0a29acc69de74219ea997b8b(tableName, whereClause) {
    try {
    result = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setRelationsDepth(2).setPageSize(100)));

  } catch (error) {
    ;await ( async function (message){ alert(message) })((error['message']));

  }


  return result
}

})
define('./functions/3cc879fa5dffc7ab99cf2ce9b6eb0ef1/code.js', () => { 

var converted, outputCurrencyCod, formattedCurrencyCode, number;



BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'] = async function fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1(number, currencyCod) {
    number = number * 100;
  number = Math.round(number);
  number = number / 100;
  if (number % 1 == 0) {
    converted = String(number) + String('.00');
  } else {
    converted = String(number);
  }
  if (!currencyCod) {
    outputCurrencyCod = '';
  } else {
    outputCurrencyCod = null;
    formattedCurrencyCode = currencyCod.trim().toUpperCase();
    if (formattedCurrencyCode.length > 3) {
      formattedCurrencyCode = formattedCurrencyCode.slice(0, 3);
    }
    if (formattedCurrencyCode == 'USD') {
      outputCurrencyCod = '$';
    }
    if (formattedCurrencyCode == 'EUR') {
      outputCurrencyCod = '&#8364;';
    }
    if (formattedCurrencyCode == 'GBP') {
      outputCurrencyCod = '&#163;';
    }
    if (formattedCurrencyCode == 'JPY') {
      outputCurrencyCod = '&#165;';
    }
    if (formattedCurrencyCode == 'CNY') {
      outputCurrencyCod = '&#65509;';
    }
    if (formattedCurrencyCode == 'RUB') {
      outputCurrencyCod = '&#8381;';
    }
    if (formattedCurrencyCode == 'UAH') {
      outputCurrencyCod = '&#8372;';
    }
    if (formattedCurrencyCode == 'INR') {
      outputCurrencyCod = '&#8360;';
    }
    if (!outputCurrencyCod) {
      outputCurrencyCod = String(formattedCurrencyCode) + String(' ');
    }
  }


  return (String(outputCurrencyCod) + String(converted.replace((new RegExp('\\B(?=(\\d{3})+(?!\\d))', 'g')), ',')))
}

})
define('./functions/53fa4eca2b347012ff2a49e239482e66/code.js', () => { 

var contactsCount, employee, lastContact, touchpoint, employeeIDfromTouchpoint, employeeID, minutes, hours, formatedDate;



BackendlessUI.Functions.Custom['fn_53fa4eca2b347012ff2a49e239482e66'] = async function fn_53fa4eca2b347012ff2a49e239482e66(employees, touchpoints) {
    for (var employee_index in employees) {
    employee = employees[employee_index];
    employeeID = (employee['objectId']);
    contactsCount = 0;
    lastContact = 0;
    for (var touchpoint_index in touchpoints) {
      touchpoint = touchpoints[touchpoint_index];
      if (touchpoint['client']) {
        employeeIDfromTouchpoint = ((touchpoint['client'])['objectId']);
        if (employeeID == employeeIDfromTouchpoint && !(touchpoint['isRepeatable'])) {
          contactsCount = (typeof contactsCount == 'number' ? contactsCount : 0) + 1;
          if (touchpoint['startDate']) {
            if ((touchpoint['startDate']) > lastContact) {
              lastContact = (touchpoint['startDate']);
            }
          }
        }
      }
    }
    if (lastContact == 0) {
      employee['lastContact'] = '-';
    } else {
      if ((new Date(lastContact).getHours()) < 10) {
        hours = String('0') + String(new Date(lastContact).getHours());
      } else {
        hours = (new Date(lastContact).getHours());
      }
      if ((new Date(lastContact).getMinutes()) < 10) {
        minutes = String('0') + String(new Date(lastContact).getMinutes());
      } else {
        minutes = (new Date(lastContact).getMinutes());
      }
      employee['lastContact'] = ([((new Date(lastContact)).toDateString()).slice(3, 10),', ',(new Date(lastContact).getFullYear()),' at ',hours,':',minutes].join(''));
    }
    employee['contactsCount'] = contactsCount;
  }


  return employees
}

})
define('./functions/726d45b76f115c38b51560439dfe0246/code.js', () => { 

var selectList, item;



BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'] = async function fn_726d45b76f115c38b51560439dfe0246(objectsList, propertyForlabel1, propertyForlabel2, initLabel) {
    selectList = (await Promise.all(objectsList.map(async item => {; return ({ 'value': (item['objectId']),'label': [(item[propertyForlabel1]),' ',(item[propertyForlabel2])].join('') });})));
  selectList.unshift(({ 'value': 'none','label': initLabel }));


  return selectList
}

})
define('./functions/751e827d97ea2b65bb8ae2fdc6c986ae/code.js', () => { 

var formatedDate, minutes, hours;



BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae'] = async function fn_751e827d97ea2b65bb8ae2fdc6c986ae(timeStamp) {
    if ((new Date(timeStamp).getHours()) < 10) {
    hours = String('0') + String(new Date(timeStamp).getHours());
  } else {
    hours = (new Date(timeStamp).getHours());
  }
  if ((new Date(timeStamp).getMinutes()) < 10) {
    minutes = String('0') + String(new Date(timeStamp).getMinutes());
  } else {
    minutes = (new Date(timeStamp).getMinutes());
  }
  formatedDate = [((new Date(timeStamp)).toDateString()).slice(3, 10),', ',(new Date(timeStamp).getFullYear()),' at ',hours,':',minutes].join('');


  return formatedDate
}

})
define('./functions/bfbd66299d3ee0ab03e971de7c94b525/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bfbd66299d3ee0ab03e971de7c94b525'] = async function fn_bfbd66299d3ee0ab03e971de7c94b525(month, year, tasks, touchpoints) {
var calendarData, nextMonth, i, nextMonthEnd, isToday, currentMonth, previousMonth, previosMonthStart, tasksData, weekDays, taskList, result, endDay, item, startDay, j, tasks, dayIndex, month, year, touchpointList, touchpoints;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function createTasks(dayIndex, month, year, tasks) {
  startDay = (new Date());
  startDay.setFullYear(year);
  startDay.setMonth(month);
  startDay.setDate(dayIndex);
  startDay.setHours(0);
  startDay.setMinutes(0);
  startDay.setSeconds(0);
  startDay.setMilliseconds(0);
  endDay = (new Date());
  endDay.setFullYear(year);
  endDay.setMonth(month);
  endDay.setDate(dayIndex);
  endDay.setHours(23);
  endDay.setMinutes(59);
  endDay.setSeconds(59);
  taskList = (await asyncListFilter(tasks, async (item) => {
     result = false;
    if (getObjectProperty(item, 'isRepeatable')) {
      if ((getObjectProperty(item, 'created')) <= (endDay.valueOf())) {
        var j_list = (getObjectProperty(item, 'repeatDays'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          if ((new Date(startDay).getDay()) == (weekDays.indexOf(j.toLowerCase()) + 1) - 1) {
            result = true;
          }
        }
      }
    } else {
      if ((getObjectProperty(item, 'dueDateTime')) >= (startDay.valueOf()) && (getObjectProperty(item, 'dueDateTime')) <= (endDay.valueOf())) {
        result = true;
      }
    }


   return result;
  }));
  return taskList
}

/**
 * Describe this function...
 */
async function createTouchpoints(dayIndex, month, year, touchpoints) {
  startDay = (new Date());
  startDay.setFullYear(year);
  startDay.setMonth(month);
  startDay.setDate(dayIndex);
  startDay.setHours(0);
  startDay.setMinutes(0);
  startDay.setSeconds(0);
  startDay.setMilliseconds(0);
  endDay = (new Date());
  endDay.setFullYear(year);
  endDay.setMonth(month);
  endDay.setDate(dayIndex);
  endDay.setHours(23);
  endDay.setMinutes(59);
  endDay.setSeconds(59);
  touchpointList = (await asyncListFilter(touchpoints, async (item) => {
     result = false;
    if (getObjectProperty(item, 'isRepeatable')) {
      if ((getObjectProperty(item, 'created')) <= (endDay.valueOf())) {
        var j_list2 = (getObjectProperty(item, 'repeatDays'));
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          if ((new Date(startDay).getDay()) == (weekDays.indexOf(j.toLowerCase()) + 1) - 1) {
            result = true;
          }
        }
      }
    } else {
      if ((getObjectProperty(item, 'startDate')) >= (startDay.valueOf()) && (getObjectProperty(item, 'startDate')) <= (endDay.valueOf())) {
        result = true;
      }
    }


   return result;
  }));
  return touchpointList
}


  currentMonth = (new Date());
  currentMonth.setFullYear(year);
  currentMonth.setMonth(month);
  currentMonth.setDate(1);
  previousMonth = (new Date());
  previousMonth.setFullYear(year);
  previousMonth.setMonth((month - 1));
  previousMonth.setDate(1);
  nextMonth = (new Date());
  nextMonth.setFullYear(year);
  nextMonth.setMonth((month + 1));
  nextMonth.setDate(1);
  weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  calendarData = [];
  tasksData = [];
  if ((new Date(currentMonth).getDay()) != 1) {
    if ((new Date(currentMonth).getDay()) == 0) {
      previosMonthStart = (new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0).getDate()) - 5;
    } else {
      previosMonthStart = (new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0).getDate()) - ((new Date(currentMonth).getDay()) - 2);
    }
    var i_end = (new Date(previousMonth.getFullYear(), previousMonth.getMonth() + 1, 0).getDate());
    var i_inc = 1;
    if (previosMonthStart > i_end) {
      i_inc = -i_inc;
    }
    for (i = previosMonthStart; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      addItemToList(calendarData, ({ 'date': i,'tasks': await createTasks(i, (new Date(previousMonth).getMonth()), (new Date(previousMonth).getFullYear()), tasks),'touchpoints': await createTouchpoints(i, (new Date(previousMonth).getMonth()), (new Date(previousMonth).getFullYear()), touchpoints) }));
    }
  }
  var i_end2 = (new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate());
  var i_inc2 = 1;
  if (1 > i_end2) {
    i_inc2 = -i_inc2;
  }
  for (i = 1; i_inc2 >= 0 ? i <= i_end2 : i >= i_end2; i += i_inc2) {
    if (i == (new Date((new Date())).getDate()) && month == (new Date((new Date())).getMonth()) && year == (new Date((new Date())).getFullYear())) {
      isToday = true;
    } else {
      isToday = false;
    }
    addItemToList(calendarData, ({ 'date': i,'today': isToday,'tasks': await createTasks(i, month, year, tasks),'touchpoints': await createTouchpoints(i, month, year, touchpoints) }));
  }
  nextMonthEnd = 42 - calendarData.length;
  var i_inc3 = 1;
  if (1 > nextMonthEnd) {
    i_inc3 = -i_inc3;
  }
  for (i = 1; i_inc3 >= 0 ? i <= nextMonthEnd : i >= nextMonthEnd; i += i_inc3) {
    addItemToList(calendarData, ({ 'date': i,'tasks': await createTasks(i, (new Date(nextMonth).getMonth()), (new Date(nextMonth).getFullYear()), tasks),'touchpoints': await createTouchpoints(i, (new Date(nextMonth).getMonth()), (new Date(nextMonth).getFullYear()), touchpoints) }));
  }

return calendarData
}

})
define('./functions/fc27fcf72455ec3daa2ad39e42dbbc42/code.js', () => { 

var filteredList, item, emptyObject;



BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'] = async function fn_fc27fcf72455ec3daa2ad39e42dbbc42(objectsList, propertyName) {
    emptyObject = ({  });
  emptyObject[propertyName] = '';
  filteredList = (await (async () => {
    async function callback (item) {


      return ((item[propertyName]).length != 0);
    }

    const list = await Promise.all(objectsList.map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  if (filteredList.length == 0) {
    filteredList = [emptyObject];
  }


  return filteredList
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/calendar/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var calendarDate;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    ___arguments.context.pageData['currentMonth'] = (new Date((new Date())).getMonth());
    ___arguments.context.pageData['currentYear'] = (new Date((new Date())).getFullYear());
    ___arguments.context.pageData['months'] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    ___arguments.context.pageData['monthYear'] = ([(___arguments.context.pageData['months'])[(((___arguments.context.pageData['currentMonth']) + 1) - 1)],' ',(___arguments.context.pageData['currentYear'])].join(''));
    ___arguments.context.pageData['tasks'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', null));
    ___arguments.context.pageData['touchpoints'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Touchpoint', null));
    calendarDate = (await BackendlessUI.Functions.Custom['fn_bfbd66299d3ee0ab03e971de7c94b525']((___arguments.context.pageData['currentMonth']), (___arguments.context.pageData['currentYear']), (___arguments.context.pageData['tasks']), (___arguments.context.pageData['touchpoints'])));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4bfa6afe12347d781ff5f36abecf8c18')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4bfa6afe12347d781ff5f36abecf8c18', calendarDate);
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'flex';
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/calendar/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/f775f4dd2a0f9992e068969d0307e227/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.pageData['currentMonth']) == 11) {
    ___arguments.context.pageData['currentYear'] = ((___arguments.context.pageData['currentYear']) + 1);
    ___arguments.context.pageData['currentMonth'] = 0;
  } else {
    ___arguments.context.pageData['currentMonth'] = ((___arguments.context.pageData['currentMonth']) + 1);
  }
  ___arguments.context.pageData['monthYear'] = ([(___arguments.context.pageData['months'])[(((___arguments.context.pageData['currentMonth']) + 1) - 1)],' ',(___arguments.context.pageData['currentYear'])].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4bfa6afe12347d781ff5f36abecf8c18', (await BackendlessUI.Functions.Custom['fn_bfbd66299d3ee0ab03e971de7c94b525']((___arguments.context.pageData['currentMonth']), (___arguments.context.pageData['currentYear']), (___arguments.context.pageData['tasks']), (___arguments.context.pageData['touchpoints']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/60f2a3b12f08ec8fff7f9a94396a0dc6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((___arguments.context.pageData['currentMonth']) == 0) {
    ___arguments.context.pageData['currentYear'] = ((___arguments.context.pageData['currentYear']) - 1);
    ___arguments.context.pageData['currentMonth'] = 11;
  } else {
    ___arguments.context.pageData['currentMonth'] = ((___arguments.context.pageData['currentMonth']) - 1);
  }
  ___arguments.context.pageData['monthYear'] = ([(___arguments.context.pageData['months'])[(((___arguments.context.pageData['currentMonth']) + 1) - 1)],' ',(___arguments.context.pageData['currentYear'])].join(''));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4bfa6afe12347d781ff5f36abecf8c18', (await BackendlessUI.Functions.Custom['fn_bfbd66299d3ee0ab03e971de7c94b525']((___arguments.context.pageData['currentMonth']), (___arguments.context.pageData['currentYear']), (___arguments.context.pageData['tasks']), (___arguments.context.pageData['touchpoints']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/833c8073d855e6d30fcc54447351419b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var calendarDate;


  ___arguments.context.pageData['currentMonth'] = (new Date((new Date())).getMonth());
  ___arguments.context.pageData['currentYear'] = (new Date((new Date())).getFullYear());
  ___arguments.context.pageData['monthYear'] = ([(___arguments.context.pageData['months'])[(((___arguments.context.pageData['currentMonth']) + 1) - 1)],' ',(___arguments.context.pageData['currentYear'])].join(''));
  calendarDate = (await BackendlessUI.Functions.Custom['fn_bfbd66299d3ee0ab03e971de7c94b525']((___arguments.context.pageData['currentMonth']), (___arguments.context.pageData['currentYear']), (___arguments.context.pageData['tasks']), (___arguments.context.pageData['touchpoints'])));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4bfa6afe12347d781ff5f36abecf8c18', calendarDate);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/ed2b3c44a606293326f87b6f8ca7a5e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classList;


  if (___arguments.context.dataModel['today']) {
    classList = ['calendar__day', 'calendar__today'];
  } else {
    classList = ['calendar__day'];
  }

  return classList

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/calendar/components/9a4a0674d6a2b8e6a1f9bbec268245dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2, minutes, hours;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'isRepeatable')) {
    content2 = [(getObjectProperty(___arguments.context.dataModel, 'time')),' ',(getObjectProperty(___arguments.context.dataModel, 'name'))].join('');
  } else {
    if ((new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getHours()) < 10) {
      hours = String('0') + String(new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getHours());
    } else {
      hours = (new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getHours());
    }
    if ((new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getMinutes()) < 10) {
      minutes = String('0') + String(new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getMinutes());
    } else {
      minutes = (new Date((getObjectProperty(___arguments.context.dataModel, 'startDate'))).getMinutes());
    }
    content2 = [hours,':',minutes,' ',(getObjectProperty(___arguments.context.dataModel, 'name'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'id': (___arguments.context.dataModel['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/20d3093318816f6e9a0c196b288f9ae9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2, hours, minutes;


  if (___arguments.context.dataModel['isRepeatable']) {
    content2 = [(___arguments.context.dataModel['time']),' ',(___arguments.context.dataModel['title'])].join('');
  } else {
    if ((new Date((___arguments.context.dataModel['dueDateTime'])).getHours()) < 10) {
      hours = String('0') + String(new Date((___arguments.context.dataModel['dueDateTime'])).getHours());
    } else {
      hours = (new Date((___arguments.context.dataModel['dueDateTime'])).getHours());
    }
    if ((new Date((___arguments.context.dataModel['dueDateTime'])).getMinutes()) < 10) {
      minutes = String('0') + String(new Date((___arguments.context.dataModel['dueDateTime'])).getMinutes());
    } else {
      minutes = (new Date((___arguments.context.dataModel['dueDateTime'])).getMinutes());
    }
    content2 = [hours,':',minutes,' ',(___arguments.context.dataModel['title'])].join('');
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'id': (___arguments.context.dataModel['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/a1b40ba485b6df172223004e3ded314c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.getComponentDataStoreByUid('ed2b3c44a606293326f87b6f8ca7a5e5')['tasks']).length == 0) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/calendar/components/67eea3b56da1375ed4917ab8f3433a4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.getComponentDataStoreByUid('ed2b3c44a606293326f87b6f8ca7a5e5')['touchpoints']).length == 0) {
    visible = false;
  } else {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/calendar/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/calendar/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientLogin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      await (async function() {
  	const inputs = document.getElementsByTagName('Input');
  	for (let input of inputs) {
  	  input.setAttribute('maxlength', '150');
  	}

  })();

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientLogin/components/05e1c38560e2f59ff4c54f897001f3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, companyId;


  try {
    companyId = (await Backendless.Request.post(`${Backendless.appPath}/services/clientZoneLogin/clientZoneLogin`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).send({ 'email': (___arguments.context.dataModel['userName']),'password': (___arguments.context.dataModel['password']) }));
    if (companyId) {
      localStorage.setItem('clientLogin', JSON.stringify(companyId));
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientZone', ({ 'id': companyId,'remember': (___arguments.context.dataModel['rememberMe']) }));
    } else {
      ___arguments.context.pageData['errorMessage'] = 'Incorrect password or email';
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', true);
    }

  } catch (error) {
    ___arguments.context.pageData['errorMessage'] = (error['message']);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', true);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/clientLogin/components/c751b4a53d646cbef7feeabe3ce31339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientLogin/components/c2ee0008ac92604402c4fea4c0ca2356/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('05e1c38560e2f59ff4c54f897001f3c5')['rememberMe'] = (!(___arguments.context.getComponentDataStoreByUid('05e1c38560e2f59ff4c54f897001f3c5')['rememberMe']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientLogin/components/d67e60ee38cf83a9430ef628e7f9c839/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('resetClientPass', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZone/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listTasks, j, taskItem, projectTasks, project;


  if (!((function(){ try { return JSON.parse(localStorage.getItem('clientLogin')) } catch(e){ return null }})())) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);
  }
  if (((function(){ try { return JSON.parse(localStorage.getItem('clientLogin')) } catch(e){ return null }})()) != (___arguments.context.pageData['id'])) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);
  }
  if (!(___arguments.context.pageData['remember'])) {
    localStorage.removeItem('clientLogin');
  }
  if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed')) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
  }
  if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4474a4eac59ffd3be418ad79455ab919')) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
  }
  ___arguments.context.pageData['invoices'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Invoice', (['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))));
  if ((___arguments.context.pageData['invoices']).length != 0) {
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['invoices']));
    }
  }
  ___arguments.context.pageData['projects'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', (['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))));
  ___arguments.context.pageData['tasks'] = (await Promise.all((___arguments.context.pageData['projects']).map(async project => {  projectTasks = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', (['project.objectId=\'',(project['objectId']),'\''].join(''))));
    project['tasks'] = projectTasks;
  ; return projectTasks;})));
  if ((___arguments.context.pageData['projects']).length != 0) {
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('be5d045457c3ccad6269824a354a2fa3')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('be5d045457c3ccad6269824a354a2fa3', (___arguments.context.pageData['projects']));
    }
  }
  listTasks = [];
  var taskItem_list = (___arguments.context.pageData['tasks']);
  for (var taskItem_index in taskItem_list) {
    taskItem = taskItem_list[taskItem_index];
    listTasks = (listTasks.concat(taskItem));
  }
  for (var j_index in listTasks) {
    j = listTasks[j_index];
    if (j['assignTo']) {
      j['assignTo'] = ((await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(j['assignTo'])], true, null))[0]);
    }
  }
  ___arguments.context.pageData['listTasks'] = listTasks;
  if (listTasks.length != 0) {
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b43e9c3b2ee6995e1b937337bd2dfb3b')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43e9c3b2ee6995e1b937337bd2dfb3b', listTasks);
    }
  }
  if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
  }
  if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed')) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/clientZone/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZone/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var issuedDate, date, month, year;


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('632df21bc52bdceff8b907095f1cf3dc'))['display'] = 'flex';
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']) {
    year = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getFullYear());
    month = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getMonth()) + 1;
    if (month < 10) {
      month = String(0) + String(month);
    }
    date = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getDate());
    if (date < 10) {
      date = String(0) + String(date);
    }
    issuedDate = [year,'-',month,'-',date].join('');
  } else {
    issuedDate = '-';
  }
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await Backendless.Request.get(`${Backendless.appPath}/services/createPDF/createInvoice`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'id': JSON.stringify((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])),'issuedDate': JSON.stringify(issuedDate) }).send()), true, null);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('632df21bc52bdceff8b907095f1cf3dc'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/clientZone/components/7c097804ad996759a9f365412cfcfdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('#') + String(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['number']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/362795b8fbbe8fb12ea85597c917630d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var minutes, hours;



  return ([((new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']))).toDateString()).slice(3, 10),', ',(new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getFullYear())].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/a4f1c9ffbebe55fab585a5aa76764f6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item, price, tax, totalPrice;


  totalPrice = 0;
  var item_list = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['invoiceItems']);
  for (var item_index in item_list) {
    item = item_list[item_index];
    tax = (item['quantity']) * (item['unitPrice']) * ((item['tax']) / 100);
    price = (item['quantity']) * (item['unitPrice']) + tax;
    totalPrice = totalPrice + price;
  }

  return (String('$') + String(await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](totalPrice)))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/a9e466b9c07d15933e6a07c5c782038a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['invoices']) {
    if ((___arguments.context.pageData['invoices']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZone/components/117a0848685692a4a5712c4b6b791741/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['invoices']) {
    if ((___arguments.context.pageData['invoices']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZone/components/5d8846a6f0461ee610a1424ce0f5e81c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var progress, projectTasks, resolvedTasks, projectTask;


  projectTasks = (___arguments.context.getComponentDataStoreByUid('cfb5d8e8acbae6ba6b725ee14361001e')['tasks']);
  if (projectTasks.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5d8846a6f0461ee610a1424ce0f5e81c'))['width'] = 0;
  } else {
    resolvedTasks = (await (async () => {
      async function callback (projectTask) {


        return ((projectTask['status']) == 'resolved');
      }

      const list = await Promise.all(projectTasks.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5d8846a6f0461ee610a1424ce0f5e81c'))['width'] = (String(progress) + String('%'));
  }

  return ''

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/ded4ac8bab71653b64180015c9d95a1d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var progress, projectTask, projectTasks, resolvedTasks, result, task, tooltipContent;


  projectTasks = (___arguments.context.getComponentDataStoreByUid('cfb5d8e8acbae6ba6b725ee14361001e')['tasks']);
  if (projectTasks.length == 0) {
    tooltipContent = String(0) + String('% done');
  } else {
    resolvedTasks = (await (async () => {
      async function callback (projectTask) {


        return ((projectTask['status']) == 'resolved');
      }

      const list = await Promise.all(projectTasks.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    tooltipContent = String(Math.round(progress)) + String('% done');
  }

  return tooltipContent

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/2f2df0710c26c5b1e5ce67c45135361d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['projects']) {
    if ((___arguments.context.pageData['projects']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZone/components/ad41d345447ae66399f91369f1b6e013/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['projects']) {
    if ((___arguments.context.pageData['projects']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZone/components/8e47d01ff2b19604fa9707ed7ac64aea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo']) {
    content2 = [((___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo'])['firstName']),' ',((___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo'])['lastName'])].join('');
  } else {
    content2 = '';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/49564a72f57748227202d746a4ba955d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo'])['avatar']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('49564a72f57748227202d746a4ba955d'))['background'] = ((___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo'])['avatarBgColor']);
      content2 = ((___arguments.context.getComponentDataStoreByUid('21b69e2c4b3faceaa557ddc23ea4a838')['assignTo'])['avatarContent']);
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/clientZone/components/d342e02873d52eeda80db56c25299781/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['listTasks']) {
    if ((___arguments.context.pageData['listTasks']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/clientZone/components/9ddb88ed33d6e725690d889719fd5bda/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = true;
  if (___arguments.context.pageData['listTasks']) {
    if ((___arguments.context.pageData['listTasks']).length == 0) {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/colleagueCreate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var isAdmin, role;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    var role_list = (await Backendless.UserService.getUserRoles());
    for (var role_index in role_list) {
      role = role_list[role_index];
      if (role == 'Admin') {
        isAdmin = true;
      }
    }
    if (!isAdmin) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/colleagueCreate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/a039e1cc55c673fa1c47ad6359895245/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f7daabb72ad0b687f8ec8f981aefbb2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/253341119a0328c8620ae0d161a1746e/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
    function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['image'] = (subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.indexOf('files') + 1 + 5) - 1)));
  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = '';

  },  
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    var canUpload;


  canUpload = true;
  if (((___arguments.files[0])['size']) > 2097152) {
    canUpload = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', true);
    throw (new Error('Could not upload!'))
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', true);
  }

  return canUpload

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = (___arguments.error['message']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);

  },  
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/colleagueCreate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, user, isValid;


  isValid = true;
  if (___arguments.context.dataModel['website']) {
    if (!(___arguments.context.dataModel['isWebsiteValid'])) {
      isValid = false;
    }
  }
  if (___arguments.context.dataModel['passwordConfirmation']) {
    if (!(___arguments.context.dataModel['isConfirmValid'])) {
      isValid = false;
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b7f8e125cdd51fdb2df9b3282d272ae5')));
  }
  if (___arguments.context.dataModel['password']) {
    if (!(___arguments.context.dataModel['isPasswordValid'])) {
      isValid = false;
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a0b45bb34363368ab158c1c4dfccde41')));
  }
  if (___arguments.context.dataModel['email']) {
    if (!(___arguments.context.dataModel['isEmailValid'])) {
      isValid = false;
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
  }
  if (___arguments.context.dataModel['phoneNumber']) {
    if (!(___arguments.context.dataModel['isPhoneValid'])) {
      isValid = false;
    }
  }
  if (!(___arguments.context.dataModel['lastName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a039e1cc55c673fa1c47ad6359895245')));
  }
  if (!(___arguments.context.dataModel['firstName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
  }
  if (!isValid) {
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    user = (await Backendless.UserService.register( new Backendless.User({ 'firstName': (___arguments.context.dataModel['firstName']),'lastName': (___arguments.context.dataModel['lastName']),'email': (___arguments.context.dataModel['email']),'password': (___arguments.context.dataModel['password']),'phone': (___arguments.context.dataModel['phoneNumber']),'website': (___arguments.context.dataModel['website']),'image': (___arguments.context.dataModel['image']),'country': (___arguments.context.dataModel['country']),'state': (___arguments.context.dataModel['state']),'city': (___arguments.context.dataModel['city']),'street': (___arguments.context.dataModel['street']),'postalCode': (___arguments.context.dataModel['postalCode']),'twitter': (___arguments.context.dataModel['twitter']),'facebook': (___arguments.context.dataModel['facebook']),'linkedin': (___arguments.context.dataModel['linkedin']) }) ));
    if (___arguments.context.dataModel['role']) {
      await Backendless.Request.get(`${Backendless.appPath}/services/setRole/setAdminRole`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'id': JSON.stringify((user['objectId'])) }).send();
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);
    ___arguments.context.dataModel['saveBtn'] = 'Save';

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/colleagueCreate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueCreate', null);
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/2f7daabb72ad0b687f8ec8f981aefbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', true);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isEmailValid'] = false;
  } else {
    if (!((new RegExp('\\b[a-z0-9._]+@[a-z0-9.-]+\\.[a-z]{2,4}\\b', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isEmailValid'] = false;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', false);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isEmailValid'] = true;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPhoneValid'] = true;
  } else {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPhoneValid'] = false;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPhoneValid'] = true;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/d36ecfe8236be3a745d5b80352626513/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var colleague;


  if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', true);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = false;
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', false);
    if (___arguments.value.length < 5) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', false);
    }
  }
  if (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['passwordConfirmation']) {
    if (___arguments.value != (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['passwordConfirmation'])) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/50b6966ca3f8a11d51550f34f43227e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', true);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', false);
    if (___arguments.value != (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['password'])) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueCreate/components/ddde7dcbb9f24d2e6856e8e7ab8aa714/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', false);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isWebsiteValid'] = true;
  } else {
    if (!((new RegExp('https?:\\/\\/', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isWebsiteValid'] = false;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', false);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isWebsiteValid'] = true;
    }
  }

  },  
  /* handler:onChange */
  /* handler:onFocus */
  onFocus(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'] = 'https://';
  }

  },  
  /* handler:onFocus */
  /* content */
}))

define('./pages/colleagueCreate/components/f8d65568f7460913e32f84f239ae369f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('66e5a1a2cd44a11a4f666dea2db84b07')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/e6b1a7581b4be95b413278e6fa278229/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6379ecf7dfc701054cc76c63d1f166e2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/a0b45bb34363368ab158c1c4dfccde41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d36ecfe8236be3a745d5b80352626513')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/b7f8e125cdd51fdb2df9b3282d272ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('50b6966ca3f8a11d51550f34f43227e8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/d6aee54325fd0773b113997460abc2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0b38ebcb3c2e48d8d777eac38d7ecb4f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/33fdd9dcce8da27e438870238dc501aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c073537134bc66ed3c5ccd2f6afc1aa4')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/ec9673554ad4710b63c2169c829ac2e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08bf1dcf1526c2e7d8fc33867be49b54')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/057629a58cdbd328a9449882c6e7e5ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5b13ee5396012dabddc66786c62da3b1')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/9f1bde448741e77233b4e3f7557d8806/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e23d14d7505881259aa3187ed0c37dcb')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/1edf7e6b0fb8c92c4ac111f14ae181ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e8573b6ce594f3368f490ccec05acc23')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/1c7baf4288390d54145ccb2bd6aa16b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('52587611ace52f8e5b5a937ebb7d3ff2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/9e268a2b95d81c096647892cc03dc1a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('10cf3039c15dbee82c04fe4a9282bfc3')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueCreate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentUser;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    currentUser = (await Backendless.UserService.getCurrentUser(true));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['image'] = (currentUser['image']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['firstName'] = (currentUser['firstName']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['lastName'] = (currentUser['lastName']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['email'] = (currentUser['email']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['website'] = (currentUser['website']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['phoneNumber'] = (currentUser['phone']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['country'] = (currentUser['country']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['state'] = (currentUser['state']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['city'] = (currentUser['city']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['street'] = (currentUser['street']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['postalCode'] = (currentUser['postalCode']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['twitter'] = (currentUser['twitter']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['facebook'] = (currentUser['facebook']);
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['linkedin'] = (currentUser['linkedin']);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/colleagueUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/a039e1cc55c673fa1c47ad6359895245/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f7daabb72ad0b687f8ec8f981aefbb2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/253341119a0328c8620ae0d161a1746e/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
    function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['image'] = (subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.indexOf('files') + 1 + 5) - 1)));
  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = '';

  },  
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    var canUpload;


  canUpload = true;
  if (((___arguments.files[0])['size']) > 2097152) {
    canUpload = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', true);
    throw (new Error('Could not upload!'))
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', true);
  }

  return canUpload

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = (___arguments.error['message']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);

  },  
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/colleagueUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, isValid;


  isValid = true;
  if (___arguments.context.dataModel['website']) {
    if (!((new RegExp('https?:\\/\\/', 'i')).test((___arguments.context.dataModel['website'])))) {
      isValid = false;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', true);
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6d051d7b51622dcdc1ffae89fb14e69b')));
    }
  }
  if (___arguments.context.dataModel['passwordConfirmation']) {
    if (!(___arguments.context.dataModel['isConfirmValid'])) {
      isValid = false;
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b7f8e125cdd51fdb2df9b3282d272ae5')));
  }
  if (___arguments.context.dataModel['password']) {
    if (!(___arguments.context.dataModel['isPasswordValid'])) {
      isValid = false;
    }
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a0b45bb34363368ab158c1c4dfccde41')));
  }
  if (___arguments.context.dataModel['email']) {
    if (!((new RegExp('\\b[a-z0-9._]+@[a-z0-9.-]+\\.[a-z]{2,4}\\b', 'i')).test((___arguments.context.dataModel['email'])))) {
      isValid = false;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
    }
  } else {
    isValid = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
  }
  if (___arguments.context.dataModel['phoneNumber']) {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test((___arguments.context.dataModel['phoneNumber'])))) {
      isValid = false;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f8d65568f7460913e32f84f239ae369f')));
    }
  }
  if (!(___arguments.context.dataModel['lastName'])) {
    isValid = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a039e1cc55c673fa1c47ad6359895245')));
  }
  if (!(___arguments.context.dataModel['firstName'])) {
    isValid = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
  }
  if (!isValid) {
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    await Backendless.UserService.update( new Backendless.User(({ 'objectId': ((await Backendless.UserService.getCurrentUser(false))['objectId']),'firstName': (___arguments.context.dataModel['firstName']),'lastName': (___arguments.context.dataModel['lastName']),'email': (___arguments.context.dataModel['email']),'password': (___arguments.context.dataModel['password']),'phone': (___arguments.context.dataModel['phoneNumber']),'website': (___arguments.context.dataModel['website']),'image': (___arguments.context.dataModel['image']),'country': (___arguments.context.dataModel['country']),'state': (___arguments.context.dataModel['state']),'city': (___arguments.context.dataModel['city']),'street': (___arguments.context.dataModel['street']),'postalCode': (___arguments.context.dataModel['postalCode']),'twitter': (___arguments.context.dataModel['twitter']),'facebook': (___arguments.context.dataModel['facebook']),'linkedin': (___arguments.context.dataModel['linkedin']) })) );
    await Backendless.UserService.login( (___arguments.context.dataModel['email']), (___arguments.context.dataModel['password']), (___arguments.context.appData['rememberMe'])  );
    ___arguments.context.pageData['alertMessage'] = 'Profile has been successfully saved.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('51478c34191635e676cef9133c041228'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('1d5172c3f0d1384f3bfff99c9e5618f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('51478c34191635e676cef9133c041228'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('1d5172c3f0d1384f3bfff99c9e5618f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ___arguments.context.dataModel['saveBtn'] = 'Save';

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/colleagueUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/2f7daabb72ad0b687f8ec8f981aefbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', true);
  } else {
    if (!((new RegExp('\\b[a-z0-9._]+@[a-z0-9.-]+\\.[a-z]{2,4}\\b', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isEmailValid'] = false;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5eb9bd419898026c6b92c754af92b3ed', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
  } else {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/d36ecfe8236be3a745d5b80352626513/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var colleague;


  if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', true);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = false;
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('409fff4ff8b6261679ddded1abf59a43', false);
    if (___arguments.value.length < 5) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isPasswordValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e68e169b020bca49f4010765c5d6318d', false);
    }
  }
  if (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['passwordConfirmation']) {
    if (___arguments.value != (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['passwordConfirmation'])) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/50b6966ca3f8a11d51550f34f43227e8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', true);
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6e6bc7349542342137b6b906bf4347cf', false);
    if (___arguments.value != (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['password'])) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', true);
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['isConfirmValid'] = true;
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('460d710822119656067cf6285194fdc2', false);
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/colleagueUpdate/components/ddde7dcbb9f24d2e6856e8e7ab8aa714/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', false);
  } else {
    if (!((new RegExp('https?:\\/\\/', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', true);
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d21940e5f855df8942c59b8253465a02', false);
    }
  }

  },  
  /* handler:onChange */
  /* handler:onFocus */
  onFocus(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'] = 'https://';
  }

  },  
  /* handler:onFocus */
  /* content */
}))

define('./pages/colleagueUpdate/components/f8d65568f7460913e32f84f239ae369f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('66e5a1a2cd44a11a4f666dea2db84b07')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/e6b1a7581b4be95b413278e6fa278229/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6379ecf7dfc701054cc76c63d1f166e2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/a0b45bb34363368ab158c1c4dfccde41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d36ecfe8236be3a745d5b80352626513')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/b7f8e125cdd51fdb2df9b3282d272ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('50b6966ca3f8a11d51550f34f43227e8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/d6aee54325fd0773b113997460abc2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0b38ebcb3c2e48d8d777eac38d7ecb4f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/33fdd9dcce8da27e438870238dc501aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c073537134bc66ed3c5ccd2f6afc1aa4')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/ec9673554ad4710b63c2169c829ac2e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('08bf1dcf1526c2e7d8fc33867be49b54')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/057629a58cdbd328a9449882c6e7e5ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5b13ee5396012dabddc66786c62da3b1')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/9f1bde448741e77233b4e3f7557d8806/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e23d14d7505881259aa3187ed0c37dcb')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/1edf7e6b0fb8c92c4ac111f14ae181ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e8573b6ce594f3368f490ccec05acc23')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/1c7baf4288390d54145ccb2bd6aa16b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('52587611ace52f8e5b5a937ebb7d3ff2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/9e268a2b95d81c096647892cc03dc1a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('10cf3039c15dbee82c04fe4a9282bfc3')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/b5e8626dae2db3e6e41e36952ae6408f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7df58365b4ec803fa9161808df1b427f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/08c9c7df6e75ba9462baee0ce002fc98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('1d5172c3f0d1384f3bfff99c9e5618f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagueUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tasksNumber, user, task, role;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    var role_list = (await Backendless.UserService.getUserRoles());
    for (var role_index in role_list) {
      role = role_list[role_index];
      if (role == 'Admin') {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03ce343bcfc5447b957713f3ebbbf2f7', true);
        ___arguments.context.pageData['deleteBtnVisible'] = true;
      }
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Colleague has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tasks'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((___arguments.context.pageData['tableList']), true, null));
    ___arguments.context.pageData['tableList'] = (await Promise.all((___arguments.context.pageData['tableList']).map(async user => {  if ((user['objectId']) == ((await Backendless.UserService.getCurrentUser(false))['objectId'])) {
        user['lastName'] = (String(user['lastName']) + String(' (You)'));
      }
    ; return user;})));
    var user_list = (___arguments.context.pageData['tableList']);
    for (var user_index in user_list) {
      user = user_list[user_index];
      tasksNumber = 0;
      var task_list = (___arguments.context.pageData['tasks']);
      for (var task_index in task_list) {
        task = task_list[task_index];
        if (task['assignTo']) {
          if ((user['objectId']) == ((task['assignTo'])['objectId'])) {
            tasksNumber = (typeof tasksNumber == 'number' ? tasksNumber : 0) + 1;
          }
        }
      }
      user['tasksNumber'] = tasksNumber;
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3892f636972ee837b1b2940b137bc301')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/colleagues/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatar']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarBgColor']);
  }

  return (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarContent'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/colleagues/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueCreate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profile', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'name': [(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['firstName']),', ',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['lastName'])].join('') }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/05b5f22b8d872604dbb7db4c38b1c3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/7c097804ad996759a9f365412cfcfdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['firstName']),', ',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['lastName'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/colleagues/components/b4f1b1e5c23111bf46954478eb7f99a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, user, currentItem;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b4f1b1e5c23111bf46954478eb7f99a5'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c826d682f3c5a8cd253a48315de11481'))['display'] = 'block';
  try {
    await Backendless.Data.of(Backendless.User).remove({ objectId: (currentItem['objectId']) });
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (user) => {


     return ((currentItem['objectId']) != (user['objectId']));
    }));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    ___arguments.context.pageData['alertMessage'] = 'Colleague has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c826d682f3c5a8cd253a48315de11481'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b4f1b1e5c23111bf46954478eb7f99a5'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.pageData['deleteBtnVisible'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/colleagues/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/colleagues/components/c826d682f3c5a8cd253a48315de11481/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.pageData['deleteBtnVisible'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/companies/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectTag, listSelectAuthor;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Company has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['clientEmployees'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('ClientEmployee', null));
    ___arguments.context.pageData['projects'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', null));
    ___arguments.context.pageData['invoices'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Invoice', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\''));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((___arguments.context.pageData['tableList']), false, 'name'));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    listSelectAuthor = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null)), 'firstName', 'lastName', 'Select author'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5fed8eb2c0334bbe036e66c0d1d10a5')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d5fed8eb2c0334bbe036e66c0d1d10a5', listSelectAuthor);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', ((listSelectAuthor[0])['value']));
    }
    listSelectTag = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Tag', null)), 'name', null, 'Select one'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('51d1ae7f7fd9910908a681d852c616cd')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('51d1ae7f7fd9910908a681d852c616cd', listSelectTag);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', ((listSelectTag[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/companies/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companiesUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatar']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarBgColor']);
  }

  return (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarContent'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companies/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item, tag;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['author']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) == ((item['author'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectTag']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['tags']).length != 0) {
        var tag_list = (item['tags']);
        for (var tag_index in tag_list) {
          tag = tag_list[tag_index];
          if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectTag']) == (tag['objectId'])) {
            result = true;
            break;
          } else {
            result = false;
          }
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['name']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', 'none');
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companiesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companiesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c131b037f6aeefc74adaddad3bcbd31'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Company').save( ({ 'objectId': (currentItem['objectId']),'archive': true }) );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The company has been successfully archived';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4c131b037f6aeefc74adaddad3bcbd31'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['name LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']) != 'none') {
    addItemToList(whereClauseList, (['author.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectTag']) != 'none') {
    addItemToList(whereClauseList, (['tags.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectTag']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Company'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)))

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/b4389981c4089f13ae921b174745d56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var counter, project;


  counter = 0;
  var project_list = (___arguments.context.pageData['projects']);
  for (var project_index in project_list) {
    project = project_list[project_index];
    if ((project['company']) != null) {
      if (((project['company'])['objectId']) == (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
      }
    }
  }

  return counter

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companies/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var result, counter, clientEmployee;


  counter = 0;
  var clientEmployee_list = (___arguments.context.pageData['clientEmployees']);
  for (var clientEmployee_index in clientEmployee_list) {
    clientEmployee = clientEmployee_list[clientEmployee_index];
    if ((clientEmployee['company']) != null) {
      if (((clientEmployee['company'])['objectId']) == (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
      }
    }
  }
  if (counter == 1) {
    result = String(counter) + String('employee');
  } else {
    result = String(counter) + String(' employees');
  }

  return result

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companies/components/05b5f22b8d872604dbb7db4c38b1c3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.dataModel['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/7cb290044d0268c8e6a8dd42a1e8b05b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currencyCode, currencyCodeList, firstCurrencyCode, invoice, invoiceItem, item, list, mult, revenu, tax;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  revenu = 0;
  currencyCodeList = [];
  var invoice_list = (___arguments.context.pageData['invoices']);
  for (var invoice_index in invoice_list) {
    invoice = invoice_list[invoice_index];
    if (((invoice['status'])['name']) == 'Paid') {
      if (invoice['company']) {
        if (((invoice['company'])['objectId']) == (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) {
          addItemToList(currencyCodeList, (invoice['currencyCode']));
          var invoiceItem_list = (invoice['invoiceItems']);
          for (var invoiceItem_index in invoiceItem_list) {
            invoiceItem = invoiceItem_list[invoiceItem_index];
            mult = (invoiceItem['quantity']) * (invoiceItem['unitPrice']);
            tax = (invoiceItem['tax']) / 100;
            revenu = revenu + mult + mult * tax;
          }
        }
      }
    }
  }
  if (currencyCodeList.length == 0) {
    currencyCode = null;
  } else {
    if (currencyCodeList.length == (await asyncListFilter(currencyCodeList, async (item) => {


     return (currencyCodeList[0] == item);
    })).length) {
      currencyCode = currencyCodeList[0];
    } else {
      currencyCode = null;
    }
  }

  return (await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](revenu, currencyCode))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companies/components/7bd717892482069630b62f8b3b22cd67/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var unpaid, tax, mult, invoiceItem, invoice;


  unpaid = 0;
  var invoice_list = (___arguments.context.pageData['invoices']);
  for (var invoice_index in invoice_list) {
    invoice = invoice_list[invoice_index];
    if (((invoice['status'])['name']) != 'Paid') {
      if (invoice['company']) {
        if (((invoice['company'])['objectId']) == (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) {
          var invoiceItem_list = (invoice['invoiceItems']);
          for (var invoiceItem_index in invoiceItem_list) {
            invoiceItem = invoiceItem_list[invoiceItem_index];
            mult = (invoiceItem['quantity']) * (invoiceItem['unitPrice']);
            tax = (invoiceItem['tax']) / 100;
            unpaid = unpaid + mult + mult * tax;
          }
        }
      }
    }
  }
  if (unpaid == 0) {
    unpaid = 'All paid';
  } else {
    unpaid = String('$') + String(await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](unpaid));
  }

  return unpaid

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companies/components/7c097804ad996759a9f365412cfcfdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companyPage', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'name': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['name']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companies/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tags, emptyBillingInfoList, emptyCustomList, emptyEmailList, emptyPhoneList, tableItem, tag, tagTableItem;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('89824872445d1767f695da369a11f80c'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    emptyPhoneList = [({ 'phoneNumber': '' })];
    emptyEmailList = [({ 'email': '' })];
    emptyCustomList = [({ 'key': '','value': '' })];
    emptyBillingInfoList = [({ 'billingName': '','vat': '','reg': '' })];
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      ___arguments.context.pageData['pageTitle'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['name'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['address'] = (tableItem['address']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['website'] = (tableItem['website']);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('05099cfc2ea8bd225f35cad58c151ccc', (tableItem['billingInfo']));
      if ((tableItem['phone']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', (tableItem['phone']));
      }
      if ((tableItem['email']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', (tableItem['email']));
      }
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      if ((tableItem['billingInfo']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('05099cfc2ea8bd225f35cad58c151ccc', emptyBillingInfoList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('05099cfc2ea8bd225f35cad58c151ccc', (tableItem['billingInfo']));
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['image'] = (tableItem['image']);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Company';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('05099cfc2ea8bd225f35cad58c151ccc', emptyBillingInfoList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('89824872445d1767f695da369a11f80c'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    if (___arguments.context.pageData['update']) {
      ___arguments.context.pageData['IdCompanyLogin'] = (await Backendless.Data.of('CompanyLogin').find(Backendless.DataQueryBuilder.create().setWhereClause((['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))).setProperties('objectId').setPageSize(10)));
      if ((___arguments.context.pageData['IdCompanyLogin']).length != 0) {
        ___arguments.context.pageData['IdCompanyLogin'] = (((___arguments.context.pageData['IdCompanyLogin'])[0])['objectId']);
      } else {
        ___arguments.context.pageData['IdCompanyLogin'] = null;
      }
    }
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/companiesUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bd67e85271d1a7fbf0280f059d4fa5f2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/253341119a0328c8620ae0d161a1746e/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
    function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['image'] = (subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.indexOf('files') + 1 + 5) - 1)));
  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = '';

  },  
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    var canUpload;


  canUpload = true;
  if (((___arguments.files[0])['size']) > 2097152) {
    canUpload = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', true);
    throw (new Error('Could not upload!'))
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', true);
  }

  return canUpload

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = (___arguments.error['message']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);

  },  
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/companiesUpdate/components/c4ce382105d3b775ee995221081d7186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')).push(({ 'phoneNumber': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/b6c7698c19d6c08556bc3595d9c25dd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')).push(({ 'email': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, loginData, checkedTagsList, tag, savedObject, isValid, email, phoneNumber;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isValid = true;
  if (!(___arguments.context.dataModel['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('87960b463b5311dc37a90f88a461425e')));
  }
  if (___arguments.context.dataModel['website']) {
    if (!((/https?:\/\//i).test((___arguments.context.dataModel['website'])))) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6d051d7b51622dcdc1ffae89fb14e69b')));
    }
  }
  var phoneNumber_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index in phoneNumber_list) {
    phoneNumber = phoneNumber_list[phoneNumber_index];
    if (phoneNumber['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f8d65568f7460913e32f84f239ae369f')));
    }
    delete phoneNumber['isInvalid'];
  }
  var email_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index in email_list) {
    email = email_list[email_index];
    if (email['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
    }
    delete email['isInvalid'];
  }
  if (!isValid) {
    return false;
  }
  ___arguments.context.dataModel['saveBtn'] = 'Saving...';
  try {
    savedObject = (await Backendless.Data.of('Company').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'address': (___arguments.context.dataModel['address']),'website': (___arguments.context.dataModel['website']),'billingInfo': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('05099cfc2ea8bd225f35cad58c151ccc')),'phone': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')), 'phoneNumber')),'email': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')), 'email')),'image': (___arguments.context.dataModel['image']),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Company').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    if ((await Backendless.UserService.getCurrentUser(false)) != null) {
      await Backendless.Data.of('Company').setRelation((___arguments.context.pageData['id']), 'author', (['objectId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join('')));
    }
    if (___arguments.context.dataModel['password']) {
      loginData = (await Backendless.Data.of('CompanyLogin').save( ({ 'objectId': (___arguments.context.pageData['IdCompanyLogin']),'password': (___arguments.context.dataModel['password']) }) ));
      await Backendless.Data.of('CompanyLogin').setRelation((loginData['objectId']), 'company', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join('')));
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/companiesUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companiesUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/companiesUpdate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['email'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
  } else {
    if (!((/\b[a-z0-9._]+@[a-z0-9.-]+\.[a-z]{2,4}\b/i).test((___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['email'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/companiesUpdate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['phoneNumber'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
  } else {
    if (!((/^[0-9+\(\)\-\s]+$/i).test((___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['phoneNumber'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/companiesUpdate/components/ddde7dcbb9f24d2e6856e8e7ab8aa714/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', false);
  } else {
    if (!((/https?:\/\//i).test((___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', true);
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', false);
    }
  }

  },  
  /* handler:onChange */
  /* handler:onFocus */
  onFocus(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'] = 'https://';
  }

  },  
  /* handler:onFocus */
  /* content */
}))

define('./pages/companiesUpdate/components/87960b463b5311dc37a90f88a461425e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/6162c2cf51dd9be8591721efce3c6336/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da91ec6326fdb591ae8fb126f5be02ff')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/47c5856c9c0c1d6d667fd178a6ffb2f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ca0b882724ddc60221639b73fed98304')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/1bcd15d113f9bc1fcefe81bb6624f606/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/2d816dc375638a253689e1613a095e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c2b59201b6917e47fef6b63ba2881b09')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/7226f8e765865e53bffa50f337d8d901/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companiesUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ___arguments.context.pageData['people'] = (await Backendless.Data.of('ClientEmployee').find(Backendless.DataQueryBuilder.create().setWhereClause((['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))).setSortBy('lastName').setPageSize(100)));
    if ((___arguments.context.pageData['people']).length == 0) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e023d63f43bb47907577e1c673b97f6'))['display'] = 'none';
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('53fe29425f1683ba9139ba650538db66', (___arguments.context.pageData['people']));
    ___arguments.context.pageData['projects'] = (await Backendless.Data.of('Project').find(Backendless.DataQueryBuilder.create().setWhereClause((['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))).setSortBy('title').setPageSize(100)));
    if ((___arguments.context.pageData['projects']).length == 0) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3e12ac21e15830f7ce6b423c655b91ba'))['display'] = 'none';
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6d9bcdf0d2960bce56abb67466db08b', (___arguments.context.pageData['projects']));
    ___arguments.context.pageData['touchpoints'] = (await Backendless.Data.of('Touchpoint').find(Backendless.DataQueryBuilder.create().setWhereClause((['company.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))).setRelationsDepth(1).setSortBy('name').setPageSize(100)));
    if ((___arguments.context.pageData['touchpoints']).length == 0) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('55e6dafe63b3a20112cc075ccabcc6b1'))['display'] = 'none';
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d78bf0edc70ccab2a64df5cf18433e3f', (___arguments.context.pageData['touchpoints']));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'flex';
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/companyPage/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/86bcb3c17cb5cf6cb2d7bbafeffe53af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('peopleUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['lastName']),', ',(___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['firstName'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companyPage/components/e60ff5a294923caa0ad29d11b4c4d69d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/6a1c2528af293f5a65cd139f2e526914/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/3b45386a2f1f9b4a3becbc6812554656/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var content2, day, repeatDays;


  if (___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['isRepeatable']) {
    if ((___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['repeatDays']).length != 0) {
      repeatDays = '';
      var day_list = (___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['repeatDays']);
      for (var day_index in day_list) {
        day = day_list[day_index];
        repeatDays = String(repeatDays) + String(String(day) + String(', '));
      }
      content2 = [repeatDays.slice(0, repeatDays.length - 2),' at ',(___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['time'])].join('');
    } else {
      content2 = '';
    }
  } else {
    if (___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['startDate']) {
      content2 = (await BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae']((___arguments.context.getComponentDataStoreByUid('0d021831744e2a1b58ef4b8751ac0256')['startDate'])));
    } else {
      content2 = '';
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/companyPage/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/companyPage/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})());
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await Backendless.Data.of('Customer').find(Backendless.DataQueryBuilder.create().setRelationsDepth(2).setSortBy('created desc').setPageSize(100)));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/customers/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customersUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customersUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, currentItem, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('6c6fda239b04bdf98d15d89e5b38038d'))['display'] = 'block';
  try {
    if (currentItem['lead']) {
      (currentItem['lead'])['converted'] = false;
      await Backendless.Data.of('Lead').save( (currentItem['lead']) );
    }
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Customer').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The Customer has been successfully deleted';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('6c6fda239b04bdf98d15d89e5b38038d'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customers/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tags, emptyCustomList, emptyPhoneList, emptyEmailList, tag, tagTableItem, tableItem;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    emptyPhoneList = [({ 'phoneNumber': '' })];
    emptyEmailList = [({ 'email': '' })];
    emptyCustomList = [({ 'key': '','value': '' })];
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Customer', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      ___arguments.context.pageData['pageTitle'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['name'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['leadID'] = (tableItem['leadID']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['company'] = (tableItem['company']);
      if ((tableItem['email']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', (tableItem['email']));
      }
      if ((tableItem['phone']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', (tableItem['phone']));
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['about'] = (tableItem['about']);
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Customer';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/customersUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/56274b1267079b22c4ff91cbfeda8b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7b3b4dd9d8c345925938f13b0227dd76')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/c4ce382105d3b775ee995221081d7186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')).push(({ 'phoneNumber': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/b6c7698c19d6c08556bc3595d9c25dd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')).push(({ 'email': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, email, phoneNumber, isValid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isValid = true;
  if (!(___arguments.context.dataModel['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
  }
  var phoneNumber_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index in phoneNumber_list) {
    phoneNumber = phoneNumber_list[phoneNumber_index];
    if (phoneNumber['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f8d65568f7460913e32f84f239ae369f')));
    }
  }
  var email_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index in email_list) {
    email = email_list[email_index];
    if (email['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
    }
  }
  if (!isValid) {
    return false;
  }
  var phoneNumber_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index2 in phoneNumber_list2) {
    phoneNumber = phoneNumber_list2[phoneNumber_index2];
    delete phoneNumber['isInvalid'];
  }
  var email_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index2 in email_list2) {
    email = email_list2[email_index2];
    delete email['isInvalid'];
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Customer').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'leadID': (___arguments.context.dataModel['leadID']),'company': (___arguments.context.dataModel['company']),'about': (___arguments.context.dataModel['about']),'phone': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')), 'phoneNumber')),'email': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')), 'email')),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Customer').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    localStorage.setItem('saved', JSON.stringify('Customer has been successfully saved.'));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/customersUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customersUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/customersUpdate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
  } else {
    if (!((new RegExp('\\b[a-z0-9._]+@[a-z0-9.-]+\\.[a-z]{2,4}\\b', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/customersUpdate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
  } else {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/customersUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/customersUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var years, i, endYear, startYear, expenses, invoices, projects, dashboardData, tasks, expenseCurrencyCod, totalExpenses, expenseCurrencyCodeList, item, expense, acceptedEstimates, processingEstimates, estimate, estimates, upcomingTasks, completedTasks, processingTasks, task, invoiceCurrencyCode, earnings, paidInvoices, processingInvoices, invoiceCurrencyCodeList, invoiceItemTax, invoiceItem, invoice, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c15180dd3eafd63464eda4e8a42ecc0d'))['display'] = 'none';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    try {
      dashboardData = (await Backendless.Request.get(`${Backendless.appPath}/services/dashboard/getDashboardData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'date': JSON.stringify(((new Date()).valueOf())) }).send());

    } catch (error) {
      (function (message) { alert(message) })(error);

    }
    invoices = dashboardData[0];
    ___arguments.context.pageData['invoicesList'] = (dashboardData[0]);
    processingInvoices = 0;
    paidInvoices = 0;
    earnings = 0;
    invoiceCurrencyCodeList = [];
    for (var invoice_index in invoices) {
      invoice = invoices[invoice_index];
      if ('draft' == (getObjectProperty((getObjectProperty(invoice, 'status')), 'name')).toLowerCase().trim() || 'sent' == (getObjectProperty((getObjectProperty(invoice, 'status')), 'name')).toLowerCase().trim()) {
        processingInvoices = (typeof processingInvoices == 'number' ? processingInvoices : 0) + 1;
      }
      if ('paid' == (getObjectProperty((getObjectProperty(invoice, 'status')), 'name')).toLowerCase().trim()) {
        paidInvoices = (typeof paidInvoices == 'number' ? paidInvoices : 0) + 1;
        addItemToList(invoiceCurrencyCodeList, (getObjectProperty(invoice, 'currencyCode')));
        var invoiceItem_list = (getObjectProperty(invoice, 'invoiceItems'));
        for (var invoiceItem_index in invoiceItem_list) {
          invoiceItem = invoiceItem_list[invoiceItem_index];
          invoiceItemTax = (getObjectProperty(invoiceItem, 'quantity')) * (getObjectProperty(invoiceItem, 'unitPrice')) * ((getObjectProperty(invoiceItem, 'tax')) / 100);
          earnings = earnings + (getObjectProperty(invoiceItem, 'quantity')) * (getObjectProperty(invoiceItem, 'unitPrice')) + invoiceItemTax;
        }
      }
    }
    if (invoiceCurrencyCodeList.length == 0) {
      invoiceCurrencyCode = null;
    } else {
      if (invoiceCurrencyCodeList.length == (await asyncListFilter(invoiceCurrencyCodeList, async (item) => {


       return (item == invoiceCurrencyCodeList[0]);
      })).length) {
        invoiceCurrencyCode = invoiceCurrencyCodeList[0];
      } else {
        invoiceCurrencyCode = null;
      }
    }
    ___arguments.context.pageData['processingInvoices'] = processingInvoices;
    ___arguments.context.pageData['paidInvoices'] = paidInvoices;
    ___arguments.context.pageData['earnings'] = (String((await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](earnings, invoiceCurrencyCode))));
    tasks = dashboardData[1];
    processingTasks = 0;
    completedTasks = 0;
    upcomingTasks = [];
    for (var task_index in tasks) {
      task = tasks[task_index];
      if ('open' == (getObjectProperty(task, 'status')).toLowerCase().trim()) {
        processingTasks = (typeof processingTasks == 'number' ? processingTasks : 0) + 1;
        if ((getObjectProperty(task, 'dueDateTime')) >= (new Date())) {
          addItemToList(upcomingTasks, task);
        }
      } else {
        completedTasks = (typeof completedTasks == 'number' ? completedTasks : 0) + 1;
      }
    }
    ___arguments.context.pageData['processingTasks'] = processingTasks;
    ___arguments.context.pageData['completedTasks'] = completedTasks;
    if (upcomingTasks.length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2384c885e42e24807f72ca6b25f8f2d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb6a520ceaedb761b694df14c273f8c7', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('61387586216fbb5f0b0629a6fd0d2eb5', true);
    } else {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2384c885e42e24807f72ca6b25f8f2d')) {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e2384c885e42e24807f72ca6b25f8f2d', upcomingTasks);
      }
    }
    estimates = dashboardData[2];
    processingEstimates = 0;
    acceptedEstimates = 0;
    for (var estimate_index in estimates) {
      estimate = estimates[estimate_index];
      if ('draft' == (getObjectProperty(estimate, 'status')).toLowerCase().trim() || 'sent' == (getObjectProperty(estimate, 'status')).toLowerCase().trim()) {
        processingEstimates = (typeof processingEstimates == 'number' ? processingEstimates : 0) + 1;
      }
      if ('accepted' == (getObjectProperty(estimate, 'status')).toLowerCase().trim()) {
        acceptedEstimates = (typeof acceptedEstimates == 'number' ? acceptedEstimates : 0) + 1;
      }
    }
    ___arguments.context.pageData['processingEstimates'] = processingEstimates;
    ___arguments.context.pageData['acceptedEstimates'] = acceptedEstimates;
    expenses = dashboardData[3];
    ___arguments.context.pageData['expensesList'] = (dashboardData[3]);
    totalExpenses = 0;
    expenseCurrencyCodeList = [];
    for (var expense_index in expenses) {
      expense = expenses[expense_index];
      totalExpenses = totalExpenses + (getObjectProperty(expense, 'price'));
      addItemToList(expenseCurrencyCodeList, (getObjectProperty(expense, 'currencyCode')));
    }
    if (expenseCurrencyCodeList.length == 0) {
      expenseCurrencyCod = null;
    } else {
      if (expenseCurrencyCodeList.length == (await asyncListFilter(expenseCurrencyCodeList, async (item) => {


       return (item == expenseCurrencyCodeList[0]);
      })).length) {
        expenseCurrencyCod = expenseCurrencyCodeList[0];
      }
    }
    ___arguments.context.pageData['expenses'] = (await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](totalExpenses, expenseCurrencyCod));
    if (dashboardData[4].length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04df0c58b1b1af4cb2c6476b32c8a1dc', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('17f3889cbd281df9c96bcaf392574807', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95b30581f8052c8f6e6b506762359914', true);
    } else {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04df0c58b1b1af4cb2c6476b32c8a1dc')) {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('04df0c58b1b1af4cb2c6476b32c8a1dc', (dashboardData[4]));
      }
    }
    ___arguments.context.pageData['tasks'] = tasks;
    projects = dashboardData[5];
    if (projects.length == 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e2091afa52d4641d77d3ffa4f26c72a4', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5912177894815a855683b84cfa5e2b47', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe861c5a48a7a6faa9da2e523c7e38e9', true);
    } else {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2091afa52d4641d77d3ffa4f26c72a4')) {
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e2091afa52d4641d77d3ffa4f26c72a4', projects);
      }
    }
    if (!!invoices.length && !!expenses.length) {
      if ((new Date((getObjectProperty((invoices[0]), 'issuedDate'))).getFullYear()) <= (new Date((getObjectProperty((expenses[0]), 'expenseDate'))).getFullYear())) {
        startYear = (new Date((getObjectProperty((invoices[0]), 'issuedDate'))).getFullYear());
      } else {
        startYear = (new Date((getObjectProperty((expenses[0]), 'expenseDate'))).getFullYear());
      }
      if ((new Date((getObjectProperty((invoices.slice(-1)[0]), 'issuedDate'))).getFullYear()) >= (new Date((getObjectProperty((expenses.slice(-1)[0]), 'expenseDate'))).getFullYear())) {
        endYear = (new Date((getObjectProperty((invoices.slice(-1)[0]), 'issuedDate'))).getFullYear());
      } else {
        endYear = (new Date((getObjectProperty((expenses.slice(-1)[0]), 'expenseDate'))).getFullYear());
      }
    } else if (!!invoices.length) {
      startYear = (new Date((getObjectProperty((invoices[0]), 'issuedDate'))).getFullYear());
      endYear = (new Date((getObjectProperty((invoices.slice(-1)[0]), 'issuedDate'))).getFullYear());
    } else if (!!expenses.length) {
      startYear = (new Date((getObjectProperty((expenses[0]), 'expenseDate'))).getFullYear());
      endYear = (new Date((getObjectProperty((expenses.slice(-1)[0]), 'expenseDate'))).getFullYear());
    }
    years = [];
    var i_inc = 1;
    if (startYear > endYear) {
      i_inc = -i_inc;
    }
    for (i = startYear; i_inc >= 0 ? i <= endYear : i >= endYear; i += i_inc) {
      addItemToList(years, ({ 'year': i }));
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('adf6f5aa052d4c131b8ed32c268b4c05')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('adf6f5aa052d4c131b8ed32c268b4c05', years);
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cffe56962823cafa63922fe23c697c66')) {
      await (async function(chartData) {

      	const expenses = chartData.expenses;
      	const earnings = chartData.invoices;
      	const chartBlock = document.querySelector ('.dashboard__chartJs');

      	if ( document.getElementById('myChart') ) {
      	  chartBlock.removeChild(document.getElementById('myChart'));
      	}

      	const canvas = document.createElement('canvas');
      	      canvas.setAttribute ("id", "myChart");
      	      canvas.setAttribute ("height", "100");
      	      chartBlock.append(canvas);

      	const Chart = await BackendlessUI.requireModule('https://cdn.jsdelivr.net/npm/chart.js');

      	if (!document.getElementById('myChart')) return

      	let ctx = document.getElementById('myChart').getContext('2d');
      	  let myChart = new Chart(ctx, {
      	    type: 'bar',
      	    data: {
      	        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      	        datasets: [{
      	            label: 'Expenses',
      	            data: expenses,
      	            backgroundColor: ['rgba(15, 44, 102, 1)']
      	        },

      	        {
      	            label: 'Earnings',
      	            data: earnings,
      	            backgroundColor: ['rgba(15, 139, 227, 1)']
      	        }
      	    ]},
      	    options: {
      	        scales: {
      	            y: {
      	                beginAtZero: true
      	            }
      	        }
      	    }
      	});


      })((await BackendlessUI.Functions.Custom['fn_0328c89a9d01ef29be48a47d8e3162dc']((new Date((new Date())).getFullYear()), (getObjectProperty(___arguments.context.pageData, 'invoicesList')), (getObjectProperty(___arguments.context.pageData, 'expensesList')))));
    }
    ___arguments.context.pageData['dispalyingYear'] = (new Date((new Date())).getFullYear());
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3892f636972ee837b1b2940b137bc301')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c15180dd3eafd63464eda4e8a42ecc0d')) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c15180dd3eafd63464eda4e8a42ecc0d'))['display'] = 'flex';
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboard/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('clientLogin', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/9835c883662bb094edbd8f12937c6a28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var clientLastName, clientName, companyName;


  companyName = '';
  clientName = '';
  if (___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['company']) {
    companyName = String((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['company'])['name']) + String(' - ');
  }
  if (___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['client']) {
    clientName = [((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['client'])['lastName']),', ',((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['client'])['firstName'])].join('');
  }

  return (String(companyName) + String(clientName))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/089f810ba98fe8d7eb39c6ada9ea9321/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['type']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['type'])['type']);
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var content2, visible;


  visible = false;
  if (___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['type']) {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/dashboard/components/62225186d04e3c563d8ef33f15437a49/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if ((new Date((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['startDate'])).getDate()) < 10) {
    content2 = String(0) + String(new Date((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['startDate'])).getDate());
  } else {
    content2 = (new Date((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['startDate'])).getDate());
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/29194e46849a80cc5b524884a823949d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2, months, list;


  months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

  return (months[((new Date((___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['startDate'])).getMonth() + 1) - 1)])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/acd2376a788aaaa500bc9d9208a968dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/b6d2e99a9b35f1f2a3e6b838d5ba3d91/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('74775322256f3d6b2dc452a8a68a0868')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/17f3889cbd281df9c96bcaf392574807/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/5473ff0f31ca71c7e03885e307cd924d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var assignTo, hours, minutes;


  assignTo = '';
  if (___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['assignTo']) {
    assignTo = [' for ',((___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['assignTo'])['firstName']),' ',((___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['assignTo'])['lastName'])].join('');
  }

  return (String([((new Date((___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['dueDateTime']))).toDateString()).slice(3, 10),', ',(new Date((___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['dueDateTime'])).getFullYear())].join('')) + String(assignTo))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/a61bc0a4ae586606f45b5ab5586bdd33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/eb6a520ceaedb761b694df14c273f8c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/dda39e2b63c9b23dd267811ef7e2e814/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('46922b6c7028d5dfa21ae988e125039b')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/23ab5fb58cf9e001dac5f431c8c4c264/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var progress, projectTasks, resolvedTasks, projectTask, result, task;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  projectTasks = (await asyncListFilter((___arguments.context.pageData['tasks']), async (task) => {
     if (task['project']) {
      result = (___arguments.context.getComponentDataStoreByUid('522d8683e9ac3fc581f2f946fd88e987')['objectId']) == ((task['project'])['objectId']);
    } else {
      result = false;
    }


   return result;
  }));
  if (projectTasks.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('23ab5fb58cf9e001dac5f431c8c4c264'))['width'] = 0;
  } else {
    resolvedTasks = (await asyncListFilter(projectTasks, async (projectTask) => {


     return ((projectTask['status']) == 'resolved');
    }));
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('23ab5fb58cf9e001dac5f431c8c4c264'))['width'] = (String(progress) + String('%'));
  }

  return ''

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/55fe0f75037ec51edc82484994ea692c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var progress, projectTask, projectTasks, resolvedTasks, result, task, tooltipContent;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  projectTasks = (await asyncListFilter((___arguments.context.pageData['tasks']), async (task) => {
     if (task['project']) {
      result = (___arguments.context.getComponentDataStoreByUid('522d8683e9ac3fc581f2f946fd88e987')['objectId']) == ((task['project'])['objectId']);
    } else {
      result = false;
    }


   return result;
  }));
  if (projectTasks.length == 0) {
    tooltipContent = String(0) + String('% done');
  } else {
    resolvedTasks = (await asyncListFilter(projectTasks, async (projectTask) => {


     return ((projectTask['status']) == 'resolved');
    }));
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    tooltipContent = String(Math.round(progress)) + String('% done');
  }

  return tooltipContent

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/dashboard/components/f9a8aefa1dbdbdae39364c4cd1c38f9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/5912177894815a855683b84cfa5e2b47/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/f1619f9f47a3cd7ad6dbc0ceec63d40c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('522d8683e9ac3fc581f2f946fd88e987')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboard/components/5fde32dc9e8682a4fb89fad76317b16a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['dispalyingYear'] = (___arguments.context.dataModel['year']);
  await (async function() {
  	var chartData = (await BackendlessUI.Functions.Custom['fn_0328c89a9d01ef29be48a47d8e3162dc']((___arguments.context.dataModel['year']), (___arguments.context.pageData['invoicesList']), (___arguments.context.pageData['expensesList'])));

  	const expenses = chartData.expenses;
  	const earnings = chartData.invoices;
  	const chartBlock = document.querySelector ('.dashboard__chartJs');

  	if ( document.getElementById('myChart') ) {
  	  chartBlock.removeChild(document.getElementById('myChart'));
  	}

  	const canvas = document.createElement('canvas');
  	      canvas.setAttribute ("id", "myChart");
  	      canvas.setAttribute ("height", "100");
  	      chartBlock.append(canvas);

  	const Chart = await BackendlessUI.requireModule('https://cdn.jsdelivr.net/npm/chart.js');

  	let ctx = document.getElementById('myChart').getContext('2d');
  	  let myChart = new Chart(ctx, {
  	    type: 'bar',
  	    data: {
  	        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  	        datasets: [{
  	            label: 'Expenses',
  	            data: expenses,
  	            backgroundColor: ['rgba(15, 44, 102, 1)']
  	        },

  	        {
  	            label: 'Earnings',
  	            data: earnings,
  	            backgroundColor: ['rgba(15, 139, 227, 1)']
  	        }
  	    ]},
  	    options: {
  	        scales: {
  	            y: {
  	                beginAtZero: true
  	            }
  	        }
  	    }
  	});


  })();

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classList;


  classList = ['dashboard__CharYear'];
  if ((___arguments.context.dataModel['year']) == (___arguments.context.pageData['dispalyingYear'])) {
    classList = ['dashboard__CharYear', 'dashboard__CharYear--active'];
  }

  return classList

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/dashboard/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimateForAccept/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('901aa6a5e6314b8cc8a15ef91bc4ecf7'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('20fd63ab2ae29882a5840aa223998ad1'))['display'] = 'flex';
  ___arguments.context.pageData['estimate'] = ((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Estimate', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0]);
  ___arguments.context.pageData['items'] = ((___arguments.context.pageData['estimate'])['items']);
  ___arguments.context.pageData['currencyCode'] = ((___arguments.context.pageData['estimate'])['currencyCode']);
  ___arguments.context.pageData['name'] = (String('Estimate: ') + String((___arguments.context.pageData['estimate'])['name']));
  ___arguments.context.pageData['companyName'] = (String('Company: ') + String(((___arguments.context.pageData['estimate'])['company'])['name']));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6cc08c3b2ed3cdc85b1141826d905a8', ((___arguments.context.pageData['estimate'])['items']));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('20fd63ab2ae29882a5840aa223998ad1'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('901aa6a5e6314b8cc8a15ef91bc4ecf7'))['display'] = 'flex';

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/estimateForAccept/components/42059b5a1f8f2c2ebb7141333de122a4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['unitPrice']),' ',((___arguments.context.pageData['estimate'])['currencyCode'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimateForAccept/components/b908cd035f67f8dd2476f38ee56f22f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String(___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['taxRate']) + String('%'))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimateForAccept/components/23118d09dfae1da4b97518bd26034b89/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var totalPrice, itemPrice, item;


  totalPrice = 0;
  var item_list = (___arguments.context.pageData['items']);
  for (var item_index in item_list) {
    item = item_list[item_index];
    itemPrice = (item['unitPrice']) * (item['quantity']) + ((item['unitPrice']) * (item['taxRate'])) / 100;
    totalPrice = totalPrice + itemPrice;
  }

  return (['Total price: ',totalPrice,' ',(___arguments.context.pageData['currencyCode'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimateForAccept/components/3c4db61ec06c2dd868c65c0febc39aaf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var unitPrice;


  unitPrice = (___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['unitPrice']) * (___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['quantity']) + (___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['unitPrice']) * ((___arguments.context.getComponentDataStoreByUid('19076be7c50cfa5627d346d75d8cc0ef')['taxRate']) / 100);

  return ([unitPrice,' ',((___arguments.context.pageData['estimate'])['currencyCode'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimateForAccept/components/f39692ef22e317841a2b96574e6da1d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (___arguments.context.pageData['estimate'])['status'] = 'accepted';
  await Backendless.Data.of('Estimate').save( (___arguments.context.pageData['estimate']) );
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('901aa6a5e6314b8cc8a15ef91bc4ecf7'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5df66068252225a384ce29d12be6bd9e'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimateForAccept/components/4a825ec3b4868163426a4f07335329d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (___arguments.context.pageData['estimate'])['status'] = 'declined';
  await Backendless.Data.of('Estimate').save( (___arguments.context.pageData['estimate']) );
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('901aa6a5e6314b8cc8a15ef91bc4ecf7'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8abc2f2b5e146c8b3c994125effb4502'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectCompanies, listSelectAuthor, users, item, companiesWithAvatar;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Estimate has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Estimate', null));
    companiesWithAvatar = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((await Promise.all((___arguments.context.pageData['tableList']).map(async item => {; return (item['company']);}))), false, 'name'));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    listSelectAuthor = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'Select author'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3671369989949a060fd5eb99e3b8d52a')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('3671369989949a060fd5eb99e3b8d52a', listSelectAuthor);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', ((listSelectAuthor[0])['value']));
    }
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\'')), 'name', null, 'Select company'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('51d1ae7f7fd9910908a681d852c616cd')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('51d1ae7f7fd9910908a681d852c616cd', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', ((listSelectCompanies[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/estimates/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimatesUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var avatarContent, char, objectWithAvatar;


  if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatar']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background-color'] = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarBgColor']);
    avatarContent = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarContent']);
  } else {
    avatarContent = null;
  }

  return avatarContent

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = false;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if (!((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image'])) {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/estimates/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['author']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) == ((item['author'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['status']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']).toLowerCase() == (item['status']).toLowerCase()) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['company']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) == ((item['company'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['name']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', 'none');
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimatesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimatesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('11f84e4373043b0148b9cceee74c78b5'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    var item_list = (currentItem['items']);
    for (var item_index in item_list) {
      item = item_list[item_index];
      await Backendless.Data.of('EstimateItem').remove( item );
    }
    await Backendless.Data.of('Estimate').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The estimate has been successfully deleted';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('11f84e4373043b0148b9cceee74c78b5'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['name LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']) != 'none') {
    addItemToList(whereClauseList, (['status LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']) != 'none') {
    addItemToList(whereClauseList, (['company.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']) != 'none') {
    addItemToList(whereClauseList, (['author.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Estimate'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL;


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9723e80f569d1035d75a73f4a70e7e7f'))['display'] = 'flex';
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/createPDF/createEstimate`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'id': JSON.stringify((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9723e80f569d1035d75a73f4a70e7e7f'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companyPage', ({ 'id': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['objectId']),'name': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']) }));
  }

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']);
  } else {
    content2 = null;
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimates/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/80992f999d1dde2b3e774b1cae84fa9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var result, totalPrice, item, tax;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['items']) {
    totalPrice = 0;
    var item_list = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['items']);
    for (var item_index in item_list) {
      item = item_list[item_index];
      tax = (item['unitPrice']) * (item['quantity']) * ((item['taxRate']) / 100);
      totalPrice = totalPrice + tax + (item['unitPrice']) * (item['quantity']);
    }
    result = (await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](totalPrice, (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['currencyCode'])));
  } else {
    result = (await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](0, (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['currencyCode'])));
  }

  return result

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/estimates/components/55d14b74f3d87618e96ac939717b1b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var url;


  url = null;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']) {
      url = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']);
    }
  }

  return url

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/estimates/components/347703417e1c9baf95012e08e5b44275/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, recipients, estimateURL, item, currentHost;


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('347703417e1c9baf95012e08e5b44275'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fafeec9564cabb0780c824380592f544'))['display'] = 'flex';
  currentHost = (await ( async function (){ return window.location.href })()).slice(0, (await ( async function (){ return window.location.href })()).indexOf('?') + 1);
  estimateURL = [currentHost,'page=estimateForAccept&data=',(encodeURIComponent((JSON.stringify(({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']) })))))].join('');
  try {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['email']) {
        recipients = (await Promise.all(((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['email']).map(async item => {; return (item['email']);})));
        await Backendless.Messaging.sendEmail('Estimate', new Backendless.Bodyparts({ htmlmessage: (['<h3> Please follow the link to accept or decline the estimate: </h3>','<a href="',estimateURL,'">',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['name']),'</a>'].join('')) }), recipients, undefined);
        ___arguments.context.pageData['alertMessage'] = (String('Estimate has been successfully sent to ') + String(recipients));
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
        ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['status'] = 'sent';
        await Backendless.Data.of('Estimate').save( ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931') );
      }
    } else {
      ___arguments.context.pageData['alertMessage'] = 'Please check if the company email field is filled';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    }

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fafeec9564cabb0780c824380592f544'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('347703417e1c9baf95012e08e5b44275'))['display'] = 'flex';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimates/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var emptyItemsList, emptyCustomList, tableItem, estimateItems, listSelectCompanies, companies;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    emptyCustomList = [({ 'key': '','value': '' })];
    emptyItemsList = [({ 'title': '','quantity': 1,'unitPrice': '','taxRate': 20 })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    companies = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', null));
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](companies, 'name', null, 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('f13f1268a046aed5cb57e9832848e8fb', listSelectCompanies);
    ___arguments.context.pageData['deletedItems'] = [];
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Estimate', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      estimateItems = (await Backendless.Data.of('Estimate').loadRelations((___arguments.context.pageData['id']), Backendless.LoadRelationsQueryBuilder.create().setRelationName('items').setPageSize(100).setOffset(0)));
      ___arguments.context.pageData['pageTitle'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['name'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['currencyCode'] = (tableItem['currencyCode']);
      if ((tableItem['company']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f13f1268a046aed5cb57e9832848e8fb', ((tableItem['company'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f13f1268a046aed5cb57e9832848e8fb', 'none');
      }
      if (tableItem['status']) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', ((tableItem['status']).toLowerCase()));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'draft');
      }
      if (estimateItems == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', emptyItemsList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', estimateItems);
      }
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Estimate';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f13f1268a046aed5cb57e9832848e8fb', 'none');
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'draft');
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', emptyItemsList);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/estimatesUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, j, itemList, item, savedObject, isValid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isValid = true;
  if (!(___arguments.context.dataModel['currencyCode'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83da92f90de3d1b175cecb84e8e4c71e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fc2d11ed7e6671f92d5594b4944e0f5d')));
    isValid = false;
  }
  var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (!(j['title'])) {
      j['errorTitle'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if (!(j['quantity'])) {
      j['errorQuantity'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if ((j['quantity']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if (!(j['unitPrice'])) {
      j['errorUnitPrice'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if ((j['unitPrice']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if (!(j['taxRate'])) {
      j['errorTaxRate'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
    if ((j['taxRate']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ab53a3b6ce08b7e53b0f87daedf3060c')));
      isValid = false;
    }
  }
  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('f13f1268a046aed5cb57e9832848e8fb')) == 'none') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24f64605fe02e8e9b9acf4b93fbd4518', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('957b8efaaeefdc221a1cee1508f17f44')));
    isValid = false;
  }
  if (!(___arguments.context.dataModel['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4ad64513c64a6103feeed5b4d35d516a')));
    isValid = false;
  }
  if (!isValid) {
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Estimate').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'status': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('d577214ee8678185f76c9f0b43c41a47')),'currencyCode': (___arguments.context.dataModel['currencyCode']),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    await Backendless.Data.of('Estimate').setRelation((___arguments.context.pageData['id']), 'company', (['objectId=\'',((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('f13f1268a046aed5cb57e9832848e8fb')),'\''].join('')));
    var j_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      delete j['errorTitle'];
      delete j['errorQuantity'];
      delete j['errorUnitPrice'];
      delete j['errorTaxRate'];
    }
    itemList = [];
    var item_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac'));
    for (var item_index in item_list) {
      item = item_list[item_index];
      addItemToList(itemList, ((await Backendless.Data.of('EstimateItem').save( item ))['objectId']));
    }
    await Backendless.Data.of('Estimate').setRelation((___arguments.context.pageData['id']), 'items', itemList);
    if ((await Backendless.UserService.getCurrentUser(false)) != null) {
      await Backendless.Data.of('Estimate').setRelation((___arguments.context.pageData['id']), 'author', (['objectId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join('')));
    }
    if ((___arguments.context.pageData['deletedItems'])[0]) {
      var j_list3 = (___arguments.context.pageData['deletedItems']);
      for (var j_index3 in j_list3) {
        j = j_list3[j_index3];
        await Backendless.Data.of('EstimateItem').remove( j );
      }
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/estimatesUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimatesUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/58ea59b4767cf119e6426a399e84d8ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).push(({ 'title': '','quantity': 1,'unitPrice': '','taxRate': 20 }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/d53995a366b7d9cd5ae72b5be04db67b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.context.getComponentDataStoreByUid('ba5c0979ce1b5571ccd7f2fea78d7d4f')['objectId']) {
    addItemToList((___arguments.context.pageData['deletedItems']), (___arguments.context.getComponentDataStoreByUid('ba5c0979ce1b5571ccd7f2fea78d7d4f')['objectId']));
  }
  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('ba5c0979ce1b5571ccd7f2fea78d7d4f'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', [({ 'title': '','quantity': 1,'unitPrice': '','taxRate': 20 })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/da640e9cc87538a7d3dba007e70acf74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/8f0e1d7c349ca54bae26197236d5892c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('17fd5723774fdf54663f2ff8d6def252')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/ca2c2cefaa2746d9feb43f4f3f4a6636/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eda670f84dd893c93cb7179cc34e13c5')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/4ad64513c64a6103feeed5b4d35d516a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da640e9cc87538a7d3dba007e70acf74')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/8ef859ff7797cf25062f4402bf0d7bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7496262e134ee6e4fe5aaea7e0d2a812')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/7479c7a1fecd6f94f0bb80a5197baa17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5f9f3b8ecb9cf8ccfc15d38d01984ceb')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/fc2d11ed7e6671f92d5594b4944e0f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('37290e940c8db0945b947f1b9f97d8fe')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/f13f1268a046aed5cb57e9832848e8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value == 'none') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24f64605fe02e8e9b9acf4b93fbd4518', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24f64605fe02e8e9b9acf4b93fbd4518', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/37290e940c8db0945b947f1b9f97d8fe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83da92f90de3d1b175cecb84e8e4c71e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('83da92f90de3d1b175cecb84e8e4c71e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/17fd5723774fdf54663f2ff8d6def252/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db4789e7a4f791848d3fcfc99e0736ba', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('db4789e7a4f791848d3fcfc99e0736ba', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/eda670f84dd893c93cb7179cc34e13c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6465f2ec96f4bd8347bda08d0e6d8e94', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6465f2ec96f4bd8347bda08d0e6d8e94', false);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d797a467ef85a8680603bf33fd11e4f4', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d797a467ef85a8680603bf33fd11e4f4', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/7496262e134ee6e4fe5aaea7e0d2a812/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcdaa7948363376feb2db93bcf60063', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcdaa7948363376feb2db93bcf60063', false);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475d3734bac64f07ba39ff38245ef0c9', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475d3734bac64f07ba39ff38245ef0c9', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/5f9f3b8ecb9cf8ccfc15d38d01984ceb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e703eff8af78ecb29edd8db195091d92', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e703eff8af78ecb29edd8db195091d92', false);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fe93f443965018304f1f1ee298cb9c4', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fe93f443965018304f1f1ee298cb9c4', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/estimatesUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/estimatesUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('136d39bae56eb8c4694b9ecf3259ea07'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Start date';
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0396621ba15ed3ba518172f8247d6a69'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'End date';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Expense has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Expense', null));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/expenses/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expensesUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, item, result, timeAfterMidnight, timeForFilter;


  filteredList = (___arguments.context.pageData['tableList']);
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay']) {
    timeAfterMidnight = (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'])).getHours()) * 3600000 + (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'])).getMinutes()) * 60000;
    timeForFilter = (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay']) - timeAfterMidnight;
    filteredList = (await (async () => {
      async function callback (item) {
          if (item['expenseDate']) {
        if ((item['expenseDate']) >= timeForFilter) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['endDay']) {
    timeAfterMidnight = (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['endDay'])).getHours()) * 3600000 + (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['endDay'])).getMinutes()) * 60000;
    timeForFilter = (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['endDay']) - timeAfterMidnight;
    filteredList = (await (async () => {
      async function callback (item) {
          if (item['expenseDate']) {
        if ((item['expenseDate']) <= timeForFilter) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['title']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'] = null;
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['endDay'] = null;
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expensesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expensesUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cdba7c812fe99907373b1fcdd5baa769'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Expense').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'Expense has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('cdba7c812fe99907373b1fcdd5baa769'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i, timeForFilter, timeAfterMidnight;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['title LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay']) != null) {
    timeAfterMidnight = (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay'])).getHours()) * 3600000 + (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay'])).getMinutes()) * 60000;
    timeForFilter = (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay']) - timeAfterMidnight;
    addItemToList(whereClauseList, (String('expenseDate >=') + String(timeForFilter)));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['endDay']) != null) {
    timeAfterMidnight = (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['endDay'])).getHours()) * 3600000 + (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['endDay'])).getMinutes()) * 60000;
    timeForFilter = (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['endDay']) - timeAfterMidnight;
    addItemToList(whereClauseList, (String('expenseDate <=') + String(timeForFilter)));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Expense'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/8dd780ca653f0ecb8f1b552300d6e965/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var result, minutes, hours;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['expenseDate']) {
    result = [((new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['expenseDate']))).toDateString()).slice(3, 10),', ',(new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['expenseDate'])).getFullYear())].join('');
  } else {
    result = '-';
  }

  return result

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/expenses/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/85e453d2c8a4df96dc014e37476d7ae7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (String(await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1']((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['price']), (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['currencyCode']))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/expenses/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expenses/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tags, emptyCustomList, tag, tagTableItem, tableItem;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('627b66feb7e990bc9bc8ec3e566ac863'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Date';
    emptyCustomList = [({ 'key': '','value': '' })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Expense', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      if (tableItem['type']) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', ((tableItem['type']).toLowerCase()));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'none');
      }
      ___arguments.context.pageData['pageTitle'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['title'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['price'] = (tableItem['price']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['currencyCode'] = (tableItem['currencyCode']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['expenseDate'] = (tableItem['expenseDate']);
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Expense';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'none');
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/expensesUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, isFormValid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isFormValid = true;
  if (!(___arguments.context.dataModel['expenseDate'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5044e605e13471cbf1a9f4a29f25f9c2', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8215d52941b9a65def9b2c121d22eef3')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['currencyCode'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2aa811aeaa5d67b0d271a96420c0d63', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8215d52941b9a65def9b2c121d22eef3')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['price'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a94dd937887266780698e9ce3c475638', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5cc80245337ac354f46d6561a42c6bc7')));
    isFormValid = false;
  }
  if ((___arguments.context.dataModel['price']) > 10000000000000) {
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5cc80245337ac354f46d6561a42c6bc7')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['title'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f91030ed7374f91b2b4ba31d3e7f20d')));
    isFormValid = false;
  }
  if (!isFormValid) {
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Expense').save( ({ 'objectId': (___arguments.context.pageData['id']),'title': (___arguments.context.dataModel['title']),'price': (___arguments.context.dataModel['price']),'currencyCode': (___arguments.context.dataModel['currencyCode']),'expenseDate': (___arguments.context.dataModel['expenseDate']),'type': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('d577214ee8678185f76c9f0b43c41a47')),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Expense').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/expensesUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expensesUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/da640e9cc87538a7d3dba007e70acf74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/expensesUpdate/components/2f91030ed7374f91b2b4ba31d3e7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da640e9cc87538a7d3dba007e70acf74')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/5cc80245337ac354f46d6561a42c6bc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('089cec1df82f248b12fae0dd1ee7a76c')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/8215d52941b9a65def9b2c121d22eef3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('16675f132c888463089c9bb29db263ce')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/089cec1df82f248b12fae0dd1ee7a76c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a94dd937887266780698e9ce3c475638', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a94dd937887266780698e9ce3c475638', false);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('038a677a5ddb749f0e4da8da5782bc75', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('038a677a5ddb749f0e4da8da5782bc75', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/expensesUpdate/components/16675f132c888463089c9bb29db263ce/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2aa811aeaa5d67b0d271a96420c0d63', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2aa811aeaa5d67b0d271a96420c0d63', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/expensesUpdate/components/1adfb2fadcf3511f43e7eaf482d7c865/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5044e605e13471cbf1a9f4a29f25f9c2', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5044e605e13471cbf1a9f4a29f25f9c2', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/expensesUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/expensesUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var currentHost, field, option, optionsList, optionsString;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef899e2cbc78c3155690cb5b85219d6'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    currentHost = (await ( async function (){ return window.location.href })()).slice(0, (await ( async function (){ return window.location.href })()).indexOf('.app/') + 1 + 3);
    ___arguments.context.pageData['serviceURL'] = (String(currentHost) + String('/api/services/formHandler/externalFormHandler'));
    ___arguments.context.pageData['form'] = ((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Form', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0]);
    ___arguments.context.pageData['title'] = ((___arguments.context.pageData['form'])['title']);
    ___arguments.context.pageData['formId'] = ((___arguments.context.pageData['form'])['formId']);
    var field_list = ((___arguments.context.pageData['form'])['formFields']);
    for (var field_index in field_list) {
      field = field_list[field_index];
      if ((field['type']) == 'select') {
        optionsString = ((field['values']).replace((new RegExp('\\r?\\n', 'g')), ' '));
        optionsList = (await (async () => {
          async function callback (option) {


            return (option.trim());
          }

          const list = await Promise.all((optionsString.split(' ')).map(async source => ({
            source,
            value: await callback(source),
          })));

          const resultList = list.filter(item => item.value)

          return resultList.map(item => item.source)
        })());
        field['options'] = optionsList;
      }
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e3f337fefcbadd11d7e772d2d488c90c', ((___arguments.context.pageData['form'])['formFields']));
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('572c84374e68a3a2c9eda2210c57f83c', ((___arguments.context.pageData['form'])['formFields']));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bef899e2cbc78c3155690cb5b85219d6'))['display'] = 'flex';
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/formCode/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/870124ecf1e8c9fd729e76e97fb1cd64/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.dataModel['type']) == 'text') {
    visible = true;
  }
  if ((___arguments.context.dataModel['type']) == 'email') {
    visible = true;
  }
  if ((___arguments.context.dataModel['type']) == 'url') {
    visible = true;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/15784054ddad84a3e4fe71feec0804f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['type']) == 'textarea')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/e075331153a4e5afb61cb6e31fd6d33d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['type']) == 'select')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/218dcd2d2ebc8f17439ca7f9208a953d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('bcb47314b3c77604842510094762c3b5')

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/formCode/components/9a42e6a7187928d8c08d826d4708fd64/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var firstLetter, list, optionList, text;


  firstLetter = ___arguments.context.getComponentDataStoreByUid('bcb47314b3c77604842510094762c3b5').charAt(0).toUpperCase();
  optionList = ___arguments.context.getComponentDataStoreByUid('bcb47314b3c77604842510094762c3b5').split('');
  optionList.shift();

  return (String(firstLetter) + String(optionList.join('')))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/formCode/components/8ff623f1429112487f3e67abf043b403/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'text') {
    visible = true;
  }
  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'email') {
    (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('62737aa13dd8c48a991c3ce86744e9eb'))['el'])['type'] = 'email';
    visible = true;
  }
  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'url') {
    (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('62737aa13dd8c48a991c3ce86744e9eb'))['el'])['type'] = 'url';
    visible = true;
  }
  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) && visible) {
    (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('62737aa13dd8c48a991c3ce86744e9eb'))['el'])['required'] = 'required';
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/6bec8f898fc8f6fd9cb6a1a9f89c6c36/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, j, customFields, customObj, formGroup;


  var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('572c84374e68a3a2c9eda2210c57f83c'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((j['type']) == 'select') {
      if (j['required']) {
        if (!(j['value'])) {
          j['selectError'] = true;
          return false;
        }
      }
    }
  }
  if ((___arguments.context.pageData['form'])['captures']) {
    (___arguments.context.pageData['form'])['captures'] = (1 + ((___arguments.context.pageData['form'])['captures']));
  } else {
    (___arguments.context.pageData['form'])['captures'] = 1;
  }
  customFields = (await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('572c84374e68a3a2c9eda2210c57f83c')).map(async formGroup => {  if ((formGroup['type']) == 'textarea') {
      customObj = ({ 'key': (formGroup['label']),'value': (formGroup['values']) });
    } else {
      customObj = ({ 'key': (formGroup['label']),'value': (formGroup['value']) });
    }
  ; return customObj;})));
  customFields.unshift(({ 'key': ((___arguments.context.pageData['form'])['title']),'value': ((___arguments.context.pageData['form'])['formId']) }));
  try {
    await Backendless.Data.of('form').save( ({ 'objectId': (___arguments.context.pageData['id']),'captures': ((___arguments.context.pageData['form'])['captures']) }) );
    await Backendless.Data.of('Lead').save( ({ 'name': String('Lead Captured by ') + String((___arguments.context.pageData['form'])['title']),'captureFormId': ((___arguments.context.pageData['form'])['formId']),'customFields': customFields }) );
    var j_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('572c84374e68a3a2c9eda2210c57f83c'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      if ((j['type']) == 'textarea') {
        j['values'] = '';
      } else {
        j['value'] = '';
      }
    }

  } catch (error) {
    ;await ( async function (message){ alert(message) })(error);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/formCode/components/9db85c0909eb08f62d917e16b41219ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) {
    content2 = String(___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']) + String(' *');
  } else {
    content2 = (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']);
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('62737aa13dd8c48a991c3ce86744e9eb')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/5d229f791d1ee969ffdac083ffa80a36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'textarea') {
    visible = true;
  }
  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) && visible) {
    (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('dd819a59e67465812fd2a0df4237cc7c'))['el'])['required'] = 'required';
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/ee478ee1c4061b952ebef6ca05ae6c46/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) {
    content2 = String(___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']) + String(' *');
  } else {
    content2 = (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']);
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/formCode/components/511edce630a9933ba7063849f7251361/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'select') {
    visible = true;
  }
  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) && visible) {
    (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f76f91ba5f13e0ac4b62db76ebfa2ea1'))['el'])['required'] = 'required';
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/formCode/components/2542ec9da296f5267ce1fbf804861fce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['required']) {
    content2 = String(___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']) + String(' *');
  } else {
    content2 = (___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['label']);
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/formCode/components/f76f91ba5f13e0ac4b62db76ebfa2ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var option, options, text;


  if ((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['type']) == 'select') {
    options = (await Promise.all((___arguments.context.getComponentDataStoreByUid('4764fe1a9898dbf732fe1ce199ab3098')['options']).map(async option => {; return ({ 'label': String(option.charAt(0).toUpperCase()) + String(option.slice(1, option.length)),'value': option });})));
  }

  return options

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('711aaa623e16cafe4bb85c33e4840bb3', false);

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/formCode/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/formCode/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectStatus, listSelectCompanies, item, companiesWithAvatar;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0207266ee07e35e3b2ed5e595d574059'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Issued date';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Invoice has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await Backendless.Data.of('Invoice').find(Backendless.DataQueryBuilder.create().setRelationsDepth(2).setSortBy('number desc').setPageSize(100)));
    companiesWithAvatar = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((await Promise.all((___arguments.context.pageData['tableList']).map(async item => {; return (item['company']);}))), false, 'name'));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\'')), 'name', null, 'Select company'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('51d1ae7f7fd9910908a681d852c616cd')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('51d1ae7f7fd9910908a681d852c616cd', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', ((listSelectCompanies[0])['value']));
    }
    listSelectStatus = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('InvoiceStatus', null)), 'name', null, 'Select status'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5fed8eb2c0334bbe036e66c0d1d10a5')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d5fed8eb2c0334bbe036e66c0d1d10a5', listSelectStatus);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', ((listSelectStatus[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/invoices/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var invoice, lastNumber;


  lastNumber = 0;
  var invoice_list = (___arguments.context.pageData['tableList']);
  for (var invoice_index in invoice_list) {
    invoice = invoice_list[invoice_index];
    if ((invoice['number']) > lastNumber) {
      lastNumber = (invoice['number']);
    }
  }
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoicesUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true,'lastNumber': lastNumber }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var avatarContent;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatar']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background-color'] = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarBgColor']);
      avatarContent = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarContent']);
    } else {
      avatarContent = null;
    }
  }

  return avatarContent

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = false;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if (!((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image'])) {
      visible = true;
    } else {
      visible = false;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/invoices/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, timeForFilter, item, timeAfterMidnight;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['status']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']) == ((item['status'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['company']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) == ((item['company'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((String(item['number'])).indexOf((String(___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']))) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['issuedDate']) {
    timeAfterMidnight = (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['issuedDate'])).getHours()) * 3600000 + (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['issuedDate'])).getMinutes()) * 60000;
    timeForFilter = (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['issuedDate']) - timeAfterMidnight;
    filteredList = (await (async () => {
      async function callback (item) {
          if (item['issuedDate']) {
        if ((item['issuedDate']) >= timeForFilter) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return (item['number']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return (item['number']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return (item['number']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return (item['number']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', 'none');
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['issuedDate'] = null;
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var invoice, lastNumber;


  lastNumber = 0;
  var invoice_list = (___arguments.context.pageData['tableList']);
  for (var invoice_index in invoice_list) {
    invoice = invoice_list[invoice_index];
    if ((invoice['number']) > lastNumber) {
      lastNumber = (invoice['number']);
    }
  }
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoicesUpdate', ({ 'update': false,'lastNumber': lastNumber }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, currentItem, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b34e1a1b7f0e06d5bbda6aeb7e5de20a'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    var item_list = (currentItem['invoiceItems']);
    for (var item_index in item_list) {
      item = item_list[item_index];
      await Backendless.Data.of('InvoiceItem').remove( item );
    }
    await Backendless.Data.of('Invoice').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The invoice has been successfully deleted';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b34e1a1b7f0e06d5bbda6aeb7e5de20a'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i, timeForFilter, timeAfterMidnight;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['number LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']) != 'none') {
    addItemToList(whereClauseList, (['status.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']) != 'none') {
    addItemToList(whereClauseList, (['company.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['issuedDate']) != null) {
    timeAfterMidnight = (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['issuedDate'])).getHours()) * 3600000 + (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['issuedDate'])).getMinutes()) * 60000;
    timeForFilter = (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['issuedDate']) - timeAfterMidnight;
    addItemToList(whereClauseList, (String('issuedDate >=') + String(timeForFilter)));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Invoice'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, issuedDate, date, month, year;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9723e80f569d1035d75a73f4a70e7e7f'))['display'] = 'flex';
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']) {
    year = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getFullYear());
    month = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getMonth()) + 1;
    if (month < 10) {
      month = String(0) + String(month);
    }
    date = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getDate());
    if (date < 10) {
      date = String(0) + String(date);
    }
    issuedDate = [year,'-',month,'-',date].join('');
  } else {
    issuedDate = '-';
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/createPDF/createInvoice`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'id': JSON.stringify((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])),'issuedDate': JSON.stringify(issuedDate) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodePath(fileURL));
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9723e80f569d1035d75a73f4a70e7e7f'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companyPage', ({ 'id': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['objectId']),'name': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']) }));
  }

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']);
  } else {
    content2 = null;
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoices/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/80992f999d1dde2b3e774b1cae84fa9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var result, totalPrice, item, tax;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['invoiceItems']) {
    totalPrice = 0;
    var item_list = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['invoiceItems']);
    for (var item_index in item_list) {
      item = item_list[item_index];
      tax = (item['unitPrice']) * (item['quantity']) * ((item['tax']) / 100);
      totalPrice = totalPrice + tax + (item['unitPrice']) * (item['quantity']);
    }
    result = String(await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](totalPrice, (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['currencyCode'])));
  } else {
    result = (await BackendlessUI.Functions.Custom['fn_3cc879fa5dffc7ab99cf2ce9b6eb0ef1'](0, (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['currencyCode'])));
  }

  return result

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoices/components/55d14b74f3d87618e96ac939717b1b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var url;


  url = null;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']) {
      url = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']);
    }
  }

  return url

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/invoices/components/347703417e1c9baf95012e08e5b44275/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var date, error, fileURL, issuedDate, item, month, recipients, text, year;


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('347703417e1c9baf95012e08e5b44275'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fafeec9564cabb0780c824380592f544'))['display'] = 'flex';
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']) {
    year = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getFullYear());
    month = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getMonth()) + 1;
    if (month < 10) {
      month = String(0) + String(month);
    }
    date = (new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getDate());
    if (date < 10) {
      date = String(0) + String(date);
    }
    issuedDate = [year,'-',month,'-',date].join('');
  } else {
    issuedDate = '-';
  }
  try {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['email']) {
        recipients = (await Promise.all(((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['email']).map(async item => {; return (item['email']);})));
        fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/createPDF/createInvoice`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'id': JSON.stringify((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])),'issuedDate': JSON.stringify(issuedDate) }).send());
        await Backendless.Messaging.sendEmail('Invoice', new Backendless.Bodyparts({ htmlmessage: (['<h2> Invoice #',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['number']),'</h2> '].join('')) }), recipients, [(fileURL.slice(((fileURL.indexOf('/pdf') + 1) - 1), fileURL.length))]);
        await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));
        ___arguments.context.pageData['alertMessage'] = (String('Invoice has been successfully sent to ') + String(recipients));
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
        ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
      } else {
        ___arguments.context.pageData['alertMessage'] = 'Please check if the company email field is filled';
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
        ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
        ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
      }
    } else {
      ___arguments.context.pageData['alertMessage'] = 'Sorry, there is no company';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    }

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('fafeec9564cabb0780c824380592f544'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('347703417e1c9baf95012e08e5b44275'))['display'] = 'flex';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/ec88708c49b6244ced85b28ee3e7605f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var invoice, list, lastNumber;


  lastNumber = 0;
  var invoice_list = (___arguments.context.pageData['tableList']);
  for (var invoice_index in invoice_list) {
    invoice = invoice_list[invoice_index];
    if ((invoice['number']) > lastNumber) {
      lastNumber = (invoice['number']);
    }
  }
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoicesUpdate', ({ 'update': false,'lastNumber': lastNumber }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/053d76ae1ab9d46fbf8ed6c73b9f42be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']) {
    content2 = [((new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate']))).toDateString()).slice(3, 10),', ',(new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['issuedDate'])).getFullYear())].join('');
  } else {
    content2 = '-';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoices/components/7c097804ad996759a9f365412cfcfdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('#') + String(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['number']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoices/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoices/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var emptyCustomList, emptyItemsList, supplier, tableItem, invoiceItems, invoiceStatus, item, listSelectCompanies;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    emptyCustomList = [({ 'key': '','value': '' })];
    emptyItemsList = [({ 'title': '','quantity': 1,'unitPrice': null,'tax': 20 })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    ___arguments.context.pageData['companies'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', null));
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((___arguments.context.pageData['companies']), 'name', null, 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectCompanies);
    invoiceStatus = (await Promise.all((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('InvoiceStatus', null)).map(async item => {; return ({ 'value': (item['objectId']),'label': (item['name']) });})));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('31a11632da09b4cf714999e6a75bd492', invoiceStatus);
    ___arguments.context.pageData['deletedItems'] = [];
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Invoice', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      invoiceItems = (await Backendless.Data.of('Invoice').loadRelations((___arguments.context.pageData['id']), Backendless.LoadRelationsQueryBuilder.create().setRelationName('invoiceItems').setPageSize(100).setOffset(0)));
      ___arguments.context.pageData['pageTitle'] = (tableItem['number']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['issuedDate'] = (tableItem['issuedDate']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerName'] = (tableItem['customerBillingName']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['reg'] = (tableItem['customerRegNo']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vat'] = (tableItem['customerVatNo']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerDetails'] = (tableItem['customerDetails']);
      if (tableItem['supplier']) {
        ___arguments.context.pageData['supplier'] = (tableItem['supplier']);
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['supplierName'] = (tableItem['supplierBillingName']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['registrationNo'] = (tableItem['supplierRegNo']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vatNumber'] = (tableItem['supplierVatNo']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['supplierDetails'] = (tableItem['supplierDetails']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['currencyCode'] = (tableItem['currencyCode']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['paymentTerm'] = (tableItem['paymentTerm']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['instruction'] = (tableItem['instruction']);
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      if (invoiceItems == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22639293b714f783be369117637b1d22', emptyItemsList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22639293b714f783be369117637b1d22', invoiceItems);
      }
      if ((tableItem['company']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', ((tableItem['company'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      }
      if ((tableItem['status']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', ((tableItem['status'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', '37860272-2AED-4B91-92DA-18CC24B51C25');
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Invoice';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      supplier = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Supplier', null))[0];
      ___arguments.context.pageData['supplier'] = supplier;
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['supplierName'] = (supplier['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['registrationNo'] = (supplier['registrationNo']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vatNumber'] = (supplier['vatNo']);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', '37860272-2AED-4B91-92DA-18CC24B51C25');
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22639293b714f783be369117637b1d22', emptyItemsList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/invoicesUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, j, itemList, item, savedObject, supplierDetails, customerDetails, currentNumber, yearFromLastNumber, isFormValid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isFormValid = true;
  if (!(___arguments.context.dataModel['paymentTerm'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64a7c1685679284c05b393f140b14504', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eae7bf3411a23c7b9fd31268831c130b')));
    isFormValid = false;
  }
  if ((___arguments.context.dataModel['paymentTerm']) > 10000000000000) {
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eae7bf3411a23c7b9fd31268831c130b')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['currencyCode'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a512ebee6cd0ec2fd47e5bc182d4bfb', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3ca838dc407e146bbc43d8920db9150b')));
    isFormValid = false;
  }
  var item_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    if (!(item['title'])) {
      item['titleError'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if (!(item['quantity'])) {
      item['quantityError'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if ((item['quantity']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if (!(item['unitPrice'])) {
      item['UnitPriceError'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if ((item['unitPrice']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if (!(item['tax'])) {
      item['taxError'] = true;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
    if ((item['tax']) > 10000000000000) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5e51a9add829cab8850ccdafdbcbbe39')));
      isFormValid = false;
    }
  }
  if (!(___arguments.context.dataModel['vatNumber'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c411acfe899fc65ae01def383ad4798d', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('83f5cab8e58bd8863305df75dcac4d37')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['registrationNo'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1259b57f1581dc24cc39afa63ecd954b', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('314bc84f5a0bcef58952b465899d637a')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['supplierName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea66bcfb1a9da606bb8335b19764cfc5', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('13f63f258269fb3cda4a638165159711')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['vat'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78879a1b97a8996614064c0f0eebcbc9', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d6a5dda23fc302ed3e475fb6455dff76')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['reg'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c06360debf23da3513c802d5b431eaef', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e8f86b243d6616183b449da635686a5d')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['customerName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442ad08c235f970690110f030a1f4d41')));
    isFormValid = false;
  }
  if ((___arguments.context.dataModel['company']) == 'none') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a5f754e015ea887cc51608405e93395', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e276db3f7cad5d3a0135ccbac9fc30ec')));
    isFormValid = false;
  }
  if (!(___arguments.context.dataModel['issuedDate'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a3555688726cefd8b86dfad3f628219', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ac0672fc68170dfef5dd2d58148579d4')));
    isFormValid = false;
  }
  if (!isFormValid) {
    return false;
  }
  if (___arguments.context.pageData['update']) {
    currentNumber = (___arguments.context.pageData['pageTitle']);
  } else {
    currentNumber = (___arguments.context.pageData['lastNumber']) + 1;
    yearFromLastNumber = Math.floor(currentNumber / 1000000);
    if ((new Date((new Date())).getFullYear()) > yearFromLastNumber) {
      currentNumber = String(new Date((new Date())).getFullYear()) + String('000001');
      currentNumber = currentNumber * 1;
    }
  }
  if (___arguments.context.dataModel['customerDetails']) {
    customerDetails = (___arguments.context.dataModel['customerDetails']);
  } else {
    customerDetails = '';
  }
  if (___arguments.context.dataModel['supplierDetails']) {
    supplierDetails = (___arguments.context.dataModel['supplierDetails']);
  } else {
    supplierDetails = '';
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Invoice').save( ({ 'objectId': (___arguments.context.pageData['id']),'number': currentNumber,'customerRegNo': (___arguments.context.dataModel['reg']),'customerVatNo': (___arguments.context.dataModel['vat']),'customerBillingName': (___arguments.context.dataModel['customerName']),'customerDetails': customerDetails,'supplierRegNo': (___arguments.context.dataModel['registrationNo']),'supplierVatNo': (___arguments.context.dataModel['vatNumber']),'supplierBillingName': (___arguments.context.dataModel['supplierName']),'supplierDetails': supplierDetails,'issuedDate': (___arguments.context.dataModel['issuedDate']),'paymentTerm': (___arguments.context.dataModel['paymentTerm']) * 1,'currencyCode': (___arguments.context.dataModel['currencyCode']),'instruction': (___arguments.context.dataModel['instruction']),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    await Backendless.Data.of('Invoice').setRelation((___arguments.context.pageData['id']), 'company', (['objectId=\'',(___arguments.context.dataModel['company']),'\''].join('')));
    await Backendless.Data.of('Invoice').setRelation((___arguments.context.pageData['id']), 'supplier', (['objectId=\'',((___arguments.context.pageData['supplier'])['objectId']),'\''].join('')));
    await Backendless.Data.of('Invoice').setRelation((___arguments.context.pageData['id']), 'status', (['objectId=\'',(___arguments.context.dataModel['status']),'\''].join('')));
    var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      delete j['titleError'];
      delete j['quantityError'];
      delete j['UnitPriceError'];
      delete j['taxError'];
    }
    itemList = [];
    var item_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22'));
    for (var item_index2 in item_list2) {
      item = item_list2[item_index2];
      addItemToList(itemList, ((await Backendless.Data.of('Invoiceitem').save( item ))['objectId']));
    }
    await Backendless.Data.of('Invoice').setRelation((___arguments.context.pageData['id']), 'invoiceItems', itemList);
    if ((___arguments.context.pageData['deletedItems'])[0]) {
      var j_list2 = (___arguments.context.pageData['deletedItems']);
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        await Backendless.Data.of('Invoiceitem').remove( j );
      }
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/invoicesUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoicesUpdate', ({ 'update': false,'lastNumber': (___arguments.context.pageData['lastNumber']) }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/fc04379f4ac95e09905c4cb9630a381c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var billingInfo, company;


  if (___arguments.value != 'none') {
    company = (await (async () => {
      async function callback (company) {


        return (___arguments.value == (company['objectId']));
      }

      const list = await Promise.all((___arguments.context.pageData['companies']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })())[0];
    if (company['billingInfo']) {
      billingInfo = (company['billingInfo'])[0];
      if (billingInfo['billingName']) {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerName'] = (billingInfo['billingName']);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
      } else {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerName'] = '';
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
      }
      if (billingInfo['reg']) {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['reg'] = (billingInfo['reg']);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c06360debf23da3513c802d5b431eaef', false);
      } else {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['reg'] = '';
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c06360debf23da3513c802d5b431eaef', true);
      }
      if (billingInfo['vat']) {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vat'] = (billingInfo['vat']);
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78879a1b97a8996614064c0f0eebcbc9', false);
      } else {
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vat'] = '';
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78879a1b97a8996614064c0f0eebcbc9', true);
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerName'] = '';
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['reg'] = '';
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vat'] = '';
    }
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a5f754e015ea887cc51608405e93395', false);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['customerName'] = '';
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['reg'] = '';
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['vat'] = '';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a5f754e015ea887cc51608405e93395', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/47513397720f1db93921816ea72aa166/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.pageData['update']) {
    content2 = String('#') + String(___arguments.context.pageData['pageTitle']);
  } else {
    content2 = (___arguments.context.pageData['pageTitle']);
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoicesUpdate/components/5fa4cf2955c400654e8f60d8e804e377/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (String('#') + String(___arguments.context.pageData['pageTitle']))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/invoicesUpdate/components/1bcc3eafa62501169f595ff19e5c0c7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22')).push(({ 'title': '','quantity': 1,'unitPrice': null,'tax': 20 }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/b9a563e492866c410c8f2cae610f506a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.context.getComponentDataStoreByUid('cc88d2177291e00948e861eb37e28552')['objectId']) {
    addItemToList((___arguments.context.pageData['deletedItems']), (___arguments.context.getComponentDataStoreByUid('cc88d2177291e00948e861eb37e28552')['objectId']));
  }
  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22639293b714f783be369117637b1d22', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('cc88d2177291e00948e861eb37e28552'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('22639293b714f783be369117637b1d22')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('22639293b714f783be369117637b1d22', [({ 'title': '','quantity': 1,'unitPrice': null,'tax': 20 })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/442ad08c235f970690110f030a1f4d41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/e8f86b243d6616183b449da635686a5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('06c7e7869dd44d8364ad139e20973e96')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/d6a5dda23fc302ed3e475fb6455dff76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4ff16ae8b453a53a1a143d548c433f0e')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/13f63f258269fb3cda4a638165159711/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('02626974417c701191c8876e296f0587')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/314bc84f5a0bcef58952b465899d637a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('68037d9e03e48e1eaf6212af73ffb2f8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/83f5cab8e58bd8863305df75dcac4d37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('4cedb71d651c14f9d87b073672976e44')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/8514761266a444835969d8c16df98a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('011327e70b1336a58f8ebb82feac8827')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/b0a5cc4d57dd412d6b082c28a413ddbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3a88da94c0fbd028fe2cc4a497e7c965')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/7c360fabc3bfedc8a3b63dfbda681ae6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9483e2871a04fe23a7ae8eb47fdc0a4d')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/0f95e174f1ec8592b53cfeb90d3f37f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2d575a0344e3e39ee72fe9b70bba1d04')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/3ca838dc407e146bbc43d8920db9150b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eb5752661763092b3521a152558aab9d')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/eae7bf3411a23c7b9fd31268831c130b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('84943f3e36eef147f081f4ac8c246717')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/b9c9fb96ceaea0e39991c1fee08597ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a3555688726cefd8b86dfad3f628219', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a3555688726cefd8b86dfad3f628219', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/06c7e7869dd44d8364ad139e20973e96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c06360debf23da3513c802d5b431eaef', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c06360debf23da3513c802d5b431eaef', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/4ff16ae8b453a53a1a143d548c433f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78879a1b97a8996614064c0f0eebcbc9', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78879a1b97a8996614064c0f0eebcbc9', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/02626974417c701191c8876e296f0587/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea66bcfb1a9da606bb8335b19764cfc5', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea66bcfb1a9da606bb8335b19764cfc5', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/68037d9e03e48e1eaf6212af73ffb2f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1259b57f1581dc24cc39afa63ecd954b', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1259b57f1581dc24cc39afa63ecd954b', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/4cedb71d651c14f9d87b073672976e44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c411acfe899fc65ae01def383ad4798d', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c411acfe899fc65ae01def383ad4798d', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/011327e70b1336a58f8ebb82feac8827/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('255b451e56f196ff879c5e0679f275ee', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('255b451e56f196ff879c5e0679f275ee', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/3a88da94c0fbd028fe2cc4a497e7c965/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed13a1773dcba203a51877cb688e8c6e', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed13a1773dcba203a51877cb688e8c6e', true);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b22565bd9ca26f734e9a33c6be198031', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b22565bd9ca26f734e9a33c6be198031', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/9483e2871a04fe23a7ae8eb47fdc0a4d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('696f3a047df6e19c464a2cb8a88115fd', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('696f3a047df6e19c464a2cb8a88115fd', true);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d61ac7f4c6990fb5826896a2ebb811a1', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d61ac7f4c6990fb5826896a2ebb811a1', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/2d575a0344e3e39ee72fe9b70bba1d04/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9884e59e7ebe2028236887f606cd6f77', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9884e59e7ebe2028236887f606cd6f77', true);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b85097347cc78f5e017913212fb8b73', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3b85097347cc78f5e017913212fb8b73', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/eb5752661763092b3521a152558aab9d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a512ebee6cd0ec2fd47e5bc182d4bfb', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a512ebee6cd0ec2fd47e5bc182d4bfb', true);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/84943f3e36eef147f081f4ac8c246717/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64a7c1685679284c05b393f140b14504', false);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64a7c1685679284c05b393f140b14504', true);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed9b9cba4d779098bd3d59f96dc21cca', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed9b9cba4d779098bd3d59f96dc21cca', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/invoicesUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/invoicesUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Lead Form has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Form', null));
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/leadForms/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadFormsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadFormsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b1de6da3ab54e2f4361d7d0ad6624bb7'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Form').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    ___arguments.context.pageData['alertMessage'] = 'Lead Form has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b1de6da3ab54e2f4361d7d0ad6624bb7'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, customerObjectId;


  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('formCode', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/d1ed6068ca5ac3b18da8be87108c871a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['captures']) {
    content2 = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['captures']);
  } else {
    content2 = 0;
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/leadForms/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadForms/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var emptyCustomList, tableItem;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    emptyCustomList = [({ 'label': '','id': '','type': 'text','values': '','required': false })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Form', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      ___arguments.context.pageData['pageTitle'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['title'] = (tableItem['title']);
      if ((tableItem['formFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['formFields']));
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Lead Form';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/leadFormsUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'id': '','label': '','required': false,'type': 'text','values': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'id': '','label': '','required': false,'type': 'text','values': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, field, isFormValid;


  isFormValid = true;
  var field_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b'));
  for (var field_index in field_list) {
    field = field_list[field_index];
    if (!(field['id'])) {
      field['idError'] = true;
      isFormValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fa443885e22f5ca1c1aa7b896c1148ad')));
    }
    if (!(field['label'])) {
      field['labelError'] = true;
      isFormValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fa443885e22f5ca1c1aa7b896c1148ad')));
    }
  }
  if (!(___arguments.context.dataModel['title'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f91030ed7374f91b2b4ba31d3e7f20d')));
    isFormValid = false;
  }
  if (!isFormValid) {
    return false;
  }
  var field_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b'));
  for (var field_index2 in field_list2) {
    field = field_list2[field_index2];
    delete field['labelError'];
    delete field['idError'];
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    await Backendless.Data.of('Form').save( ({ 'objectId': (___arguments.context.pageData['id']),'title': (___arguments.context.dataModel['title']),'formFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) );
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/leadFormsUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadFormsUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/da640e9cc87538a7d3dba007e70acf74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadFormsUpdate/components/2f91030ed7374f91b2b4ba31d3e7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da640e9cc87538a7d3dba007e70acf74')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/5bbff7e40191b03dc0fcc9fd8716a00e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767')['required'] = (!(___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767')['required']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/442bd85af6d95fa411b46cd4c13c9195/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de16773dff8ece817c7d0668c97ba9d4', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de16773dff8ece817c7d0668c97ba9d4', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadFormsUpdate/components/d9f1f668bcd5d8e1d1210b0edfa89aac/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1f4920ed46c37871b53f26b13481c21', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f1f4920ed46c37871b53f26b13481c21', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadFormsUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadFormsUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectAuthor, users, item;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Lead has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await Backendless.Data.of('Lead').find(Backendless.DataQueryBuilder.create().setRelationsDepth(2).setSortBy('created desc').setPageSize(100)));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    listSelectAuthor = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'Select colleague'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3671369989949a060fd5eb99e3b8d52a')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('3671369989949a060fd5eb99e3b8d52a', listSelectAuthor);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', ((listSelectAuthor[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/leads/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectColleague']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['assignedTo']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectColleague']) == ((item['assignedTo'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectleadType']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['leadType']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectleadType']).toLowerCase() == (item['leadType']).toLowerCase()) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['name']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', 'none');
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('04fca84f260717bdbb9bc9160e2a0452'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Lead').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The lead has been successfully deleted';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('04fca84f260717bdbb9bc9160e2a0452'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['name LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectleadType']) != 'none') {
    addItemToList(whereClauseList, (['leadType LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectleadType']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectColleague']) != 'none') {
    addItemToList(whereClauseList, (['assignedTo.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectColleague']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Lead'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/f36dc95ebf8935d71f149be945cc8d29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var minutes, hours;



  return ([((new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['created']))).toDateString()).slice(3, 10),', ',(new Date((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['created'])).getFullYear())].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/leads/components/d1ed6068ca5ac3b18da8be87108c871a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['captureFormId']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['captureFormId']).trim().length > 0) {
      content2 = 'Yes';
    } else {
      content2 = 'No';
    }
  } else {
    content2 = 'No';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/leads/components/22ec2ee8af14fc957d9262871c737524/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  visible = false;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['leadType']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['leadType']) != 'none') {
      visible = true;
    }
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/leads/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classList;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['converted']) {
    classList = ['table__ConvertBtnDisabled'];
  } else {
    classList = ['table__download-btn', 'outline-btn'];
  }

  return classList

  },  
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var error, customerObjectId;


  if (!(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['converted'])) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3b43c363c9a234a272020d6fae6b22aa'))['display'] = 'flex';
    ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['converted'] = true;
    try {
      await Backendless.Data.of('Lead').save( ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931') );
      customerObjectId = ((await Backendless.Data.of('Customer').save( ({ 'name': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['name']),'leadId': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['leadId']),'company': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']),'email': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['email']),'phone': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['phone']),'about': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['about']),'customFields': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['customFields']) }) ))['objectId']);
      await Backendless.Data.of('Customer').setRelation(customerObjectId, 'lead', (['objectId=\'',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'\''].join('')));
      await Backendless.Data.of('Customer').setRelation(customerObjectId, 'tags', (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['tags']));
      localStorage.setItem('saved', JSON.stringify('Customer has been successfully created from lead.'));
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

    } catch (error) {
      localStorage.setItem('savedError', JSON.stringify((error['message'])));
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leads/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tags, emptyCustomList, emptyPhoneList, emptyEmailList, tag, tagTableItem, tableItem, listSelectAssignedTo, assignedTo;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    emptyPhoneList = [({ 'phoneNumber': '' })];
    emptyEmailList = [({ 'email': '' })];
    emptyCustomList = [({ 'key': '','value': '' })];
    assignedTo = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    listSelectAssignedTo = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](assignedTo, 'firstName', 'lastName', 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectAssignedTo);
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Lead', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      ___arguments.context.pageData['pageTitle'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['name'] = (tableItem['name']);
      if ((tableItem['assignedTo']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', ((tableItem['assignedTo'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['captureFormId'] = (tableItem['captureFormId']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['company'] = (tableItem['company']);
      if ((tableItem['email']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', (tableItem['email']));
      }
      if ((tableItem['phone']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', (tableItem['phone']));
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['about'] = (tableItem['about']);
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      if (tableItem['leadType']) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f1b296059f099052a45565e232ef05fc', (tableItem['leadType']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f1b296059f099052a45565e232ef05fc', 'none');
      }
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Lead';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('f1b296059f099052a45565e232ef05fc', 'none');
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/leadsUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/56274b1267079b22c4ff91cbfeda8b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7b3b4dd9d8c345925938f13b0227dd76')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/c4ce382105d3b775ee995221081d7186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')).push(({ 'phoneNumber': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/b6c7698c19d6c08556bc3595d9c25dd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')).push(({ 'email': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, email, phoneNumber, isValid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isValid = true;
  if (!(___arguments.context.dataModel['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
  }
  var phoneNumber_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index in phoneNumber_list) {
    phoneNumber = phoneNumber_list[phoneNumber_index];
    if (phoneNumber['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f8d65568f7460913e32f84f239ae369f')));
    }
  }
  var email_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index in email_list) {
    email = email_list[email_index];
    if (email['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
    }
  }
  if (!isValid) {
    return false;
  }
  var phoneNumber_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index2 in phoneNumber_list2) {
    phoneNumber = phoneNumber_list2[phoneNumber_index2];
    delete phoneNumber['isInvalid'];
  }
  var email_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index2 in email_list2) {
    email = email_list2[email_index2];
    delete email['isInvalid'];
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Lead').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'captureFormId': (___arguments.context.dataModel['captureFormId']),'company': (___arguments.context.dataModel['company']),'about': (___arguments.context.dataModel['about']),'leadType': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('f1b296059f099052a45565e232ef05fc')),'phone': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')), 'phoneNumber')),'email': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')), 'email')),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Lead').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    await Backendless.Data.of('Lead').setRelation((___arguments.context.pageData['id']), 'assignedTo', (['objectId=\'',(___arguments.context.dataModel['assignedTo']),'\''].join('')));
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/leadsUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadsUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadsUpdate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
  } else {
    if (!((new RegExp('\\b[a-z0-9._]+@[a-z0-9.-]+\\.[a-z]{2,4}\\b', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadsUpdate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
  } else {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test(___arguments.value))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/leadsUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/leadsUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) != null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);
  } else {
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/login/components/05e1c38560e2f59ff4c54f897001f3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error;


  ___arguments.context.appData['rememberMe'] = (___arguments.context.dataModel['rememberMe']);
  try {
    await Backendless.UserService.login( (___arguments.context.dataModel['userName']), (___arguments.context.dataModel['password']), (___arguments.context.dataModel['rememberMe'])  );
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', false);
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  } catch (error) {
    ___arguments.context.pageData['errorMessage'] = (error['message']);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', true);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/login/components/c751b4a53d646cbef7feeabe3ce31339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/f2a8fecd94239c0e1a257b0ae911b008/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('05e1c38560e2f59ff4c54f897001f3c5')['rememberMe'] = (!(___arguments.context.getComponentDataStoreByUid('05e1c38560e2f59ff4c54f897001f3c5')['rememberMe']));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/d67e60ee38cf83a9430ef628e7f9c839/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('resetPassword', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectTag, listSelectAuthor, listSelectCompanies;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Person has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['touchpoints'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Touchpoint', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('ClientEmployee', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((___arguments.context.pageData['tableList']), true, null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_53fa4eca2b347012ff2a49e239482e66']((___arguments.context.pageData['tableList']), (___arguments.context.pageData['touchpoints'])));
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3892f636972ee837b1b2940b137bc301')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', null)), 'name', null, 'Select company'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('75e2bbf8c472bd97bdb36ee7bab6a061')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('75e2bbf8c472bd97bdb36ee7bab6a061', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('75e2bbf8c472bd97bdb36ee7bab6a061', ((listSelectCompanies[0])['value']));
    }
    listSelectAuthor = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null)), 'firstName', 'lastName', 'Select author'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5fed8eb2c0334bbe036e66c0d1d10a5')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d5fed8eb2c0334bbe036e66c0d1d10a5', listSelectAuthor);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', ((listSelectAuthor[0])['value']));
    }
    listSelectTag = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Tag', null)), 'name', null, 'Select one'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('51d1ae7f7fd9910908a681d852c616cd')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('51d1ae7f7fd9910908a681d852c616cd', listSelectTag);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', ((listSelectTag[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/people/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('peopleUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatar']) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarBgColor']);
  }

  return (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['avatarContent'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/people/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item, tag;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['company']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) == ((item['company'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['author']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) == ((item['author'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectTag']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['tags']).length != 0) {
        var tag_list = (item['tags']);
        for (var tag_index in tag_list) {
          tag = tag_list[tag_index];
          if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectTag']) == (tag['objectId'])) {
            result = true;
            break;
          } else {
            result = false;
          }
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((((item['lastName']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) || (((item['firstName']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1)) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return (item['lastName']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return (item['lastName']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return (item['lastName']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return (item['lastName']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('75e2bbf8c472bd97bdb36ee7bab6a061', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', 'none');
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('peopleUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('peopleUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item, touchpoint;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ac87814174347e989623025b589313'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    var touchpoint_list = (___arguments.context.pageData['touchpoints']);
    for (var touchpoint_index in touchpoint_list) {
      touchpoint = touchpoint_list[touchpoint_index];
      if (touchpoint['client']) {
        if (((touchpoint['client'])['objectId']) == (currentItem['objectId'])) {
          await Backendless.Data.of('Touchpoint').remove( touchpoint );
        }
      }
    }
    await Backendless.Data.of('ClientEmployee').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'Person has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d8ac87814174347e989623025b589313'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['(lastName LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\' or firstName LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\')'].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']) != 'none') {
    addItemToList(whereClauseList, (['company.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']) != 'none') {
    addItemToList(whereClauseList, (['author.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectTag']) != 'none') {
    addItemToList(whereClauseList, (['tags.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectTag']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('ClientEmployee'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)))

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/05b5f22b8d872604dbb7db4c38b1c3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((String('mailto:') + String(___arguments.context.dataModel['email'])), true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var Company, Position;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    Company = String(' at ') + String((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']);
  } else {
    Company = '';
  }
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['position']) {
    Position = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['position']);
  } else {
    Position = '';
  }

  return (String(Position) + String(Company))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/people/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/people/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var companies, tags, emptyCustomList, emptyEmailList, emptyPhoneList, listSelectCompanies, tableItem, tag, tagTableItem;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    emptyPhoneList = [({ 'phoneNumber': '' })];
    emptyEmailList = [({ 'email': '' })];
    emptyCustomList = [({ 'key': '','value': '' })];
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    companies = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', null));
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('ClientEmployee', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      ___arguments.context.pageData['pageTitle'] = ([(tableItem['lastName']),', ',(tableItem['firstName'])].join(''));
      listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](companies, 'name', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectCompanies);
      if ((tableItem['company']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', ((tableItem['company'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['firstName'] = (tableItem['firstName']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['lastName'] = (tableItem['lastName']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['position'] = (tableItem['position']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['address'] = (tableItem['address']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['website'] = (tableItem['website']);
      if ((tableItem['phone']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', (tableItem['phone']));
      }
      if ((tableItem['email']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', (tableItem['email']));
      }
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['image'] = (tableItem['image']);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Person';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b06c7dd8f6a5299e273da5b5bca588de', emptyPhoneList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('da6fbc2c2de44cd91ee6896ef41b1b74', emptyEmailList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](companies, 'name', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('511b151d9cc3375813f6c4ae80bf0213'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/peopleUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/a039e1cc55c673fa1c47ad6359895245/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f7daabb72ad0b687f8ec8f981aefbb2')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/56274b1267079b22c4ff91cbfeda8b74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7b3b4dd9d8c345925938f13b0227dd76')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/6d051d7b51622dcdc1ffae89fb14e69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ddde7dcbb9f24d2e6856e8e7ab8aa714')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/253341119a0328c8620ae0d161a1746e/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
    function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['image'] = (subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.indexOf('files') + 1 + 5) - 1)));
  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = '';

  },  
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    var canUpload;


  canUpload = true;
  if (((___arguments.files[0])['size']) > 2097152) {
    canUpload = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', true);
    throw (new Error('Could not upload!'))
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5992ba0e21de18ec5075bfd3079a62d8', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', true);
  }

  return canUpload

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['failMessage'] = (___arguments.error['message']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d94e40fbf17fcbd330d85c189137c9bf', false);

  },  
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/peopleUpdate/components/c4ce382105d3b775ee995221081d7186/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')).push(({ 'phoneNumber': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/b6c7698c19d6c08556bc3595d9c25dd7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')).push(({ 'email': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, isValid, email, phoneNumber;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isValid = true;
  if (!(___arguments.context.dataModel['firstName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
  }
  if (!(___arguments.context.dataModel['lastName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
    isValid = false;
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a039e1cc55c673fa1c47ad6359895245')));
  }
  if (___arguments.context.dataModel['website']) {
    if (!((new RegExp('https?:\\/\\/', 'i')).test((___arguments.context.dataModel['website'])))) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6d051d7b51622dcdc1ffae89fb14e69b')));
    }
  }
  var phoneNumber_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index in phoneNumber_list) {
    phoneNumber = phoneNumber_list[phoneNumber_index];
    if (phoneNumber['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f8d65568f7460913e32f84f239ae369f')));
    }
  }
  var email_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index in email_list) {
    email = email_list[email_index];
    if (email['isInvalid']) {
      isValid = false;
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('e6b1a7581b4be95b413278e6fa278229')));
    }
  }
  if (!isValid) {
    return false;
  }
  var phoneNumber_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de'));
  for (var phoneNumber_index2 in phoneNumber_list2) {
    phoneNumber = phoneNumber_list2[phoneNumber_index2];
    delete phoneNumber['isInvalid'];
  }
  var email_list2 = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74'));
  for (var email_index2 in email_list2) {
    email = email_list2[email_index2];
    delete email['isInvalid'];
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('ClientEmployee').save( ({ 'objectId': (___arguments.context.pageData['id']),'firstName': (___arguments.context.dataModel['firstName']),'lastName': (___arguments.context.dataModel['lastName']),'position': (___arguments.context.dataModel['position']),'address': (___arguments.context.dataModel['address']),'website': (___arguments.context.dataModel['website']),'phone': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b06c7dd8f6a5299e273da5b5bca588de')), 'phoneNumber')),'email': (await BackendlessUI.Functions.Custom['fn_fc27fcf72455ec3daa2ad39e42dbbc42'](((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('da6fbc2c2de44cd91ee6896ef41b1b74')), 'email')),'image': (___arguments.context.dataModel['image']),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('ClientEmployee').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    await Backendless.Data.of('ClientEmployee').setRelation((___arguments.context.pageData['id']), 'company', (['objectId=\'',(___arguments.context.dataModel['company']),'\''].join('')));
    if ((await Backendless.UserService.getCurrentUser(false)) != null) {
      await Backendless.Data.of('ClientEmployee').setRelation((___arguments.context.pageData['id']), 'author', (['objectId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join('')));
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/peopleUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('peopleUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['firstName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/peopleUpdate/components/2f7daabb72ad0b687f8ec8f981aefbb2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['lastName'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3976a04eab336b5feddc2ae1a8da4e03', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/peopleUpdate/components/6379ecf7dfc701054cc76c63d1f166e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['email'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
    ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
  } else {
    if (!((/\b[a-z0-9._]+@[a-z0-9.-]+\.[a-z]{2,4}\b/i).test((___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['email'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', true);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85434e52f601fefdcbe64dfc4c2241d7', false);
      ___arguments.context.getComponentDataStoreByUid('b3d68c6fa5de4fabfd3e690690fe7dfa')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/peopleUpdate/components/66e5a1a2cd44a11a4f666dea2db84b07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['phoneNumber'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
    ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
  } else {
    if (!((new RegExp('^[0-9+\\(\\)\\-\\s]+$', 'i')).test((___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['phoneNumber'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', true);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = true;
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc8de68120049df59282d4eaf028d736', false);
      ___arguments.context.getComponentDataStoreByUid('f2113a09c47d07f2036df22cf0ee9bff')['isInvalid'] = false;
    }
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/peopleUpdate/components/ddde7dcbb9f24d2e6856e8e7ab8aa714/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', false);
  } else {
    if (!((new RegExp('https?:\\/\\/', 'i')).test((___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])))) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', true);
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82a226dd687b435c8a9108b801ff051', false);
    }
  }

  },  
  /* handler:onChange */
  /* handler:onFocus */
  onFocus(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'])) {
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['website'] = 'https://';
  }

  },  
  /* handler:onFocus */
  /* content */
}))

define('./pages/peopleUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/peopleUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    ___arguments.context.pageData['tasks'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', (['assignTo.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))));
    if ((___arguments.context.pageData['tasks']).length == 0) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7e023d63f43bb47907577e1c673b97f6'))['display'] = 'none';
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('53fe29425f1683ba9139ba650538db66', (___arguments.context.pageData['tasks']));
    ___arguments.context.pageData['touchpoints'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Touchpoint', (['assignedTo.objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))));
    if ((___arguments.context.pageData['touchpoints']).length == 0) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3e12ac21e15830f7ce6b423c655b91ba'))['display'] = 'none';
    }
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f6d9bcdf0d2960bce56abb67466db08b', (___arguments.context.pageData['touchpoints']));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3892f636972ee837b1b2940b137bc301'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('176e5a64a622c105388c87e389582ead'))['display'] = 'flex';
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/profile/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/f1bae053b89a7564f377826e4effd702/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var content2, repeatDays, day;


  if (___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['isRepeatable']) {
    repeatDays = '';
    var day_list = (___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['repeatDays']);
    for (var day_index in day_list) {
      day = day_list[day_index];
      repeatDays = String(repeatDays) + String(String(day) + String(', '));
    }
    content2 = [(___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['time']),' ',repeatDays.slice(0, repeatDays.length - 2)].join('');
  } else {
    if (___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['dueDateTime']) {
      content2 = (await BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae']((___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['dueDateTime'])));
    } else {
      content2 = '';
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile/components/86bcb3c17cb5cf6cb2d7bbafeffe53af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('66cb8744c5a1e188f0fb7fa932384849')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/f4391901f8a22fcbcc512c55300a2d06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var content2, repeatDays, day;


  if (___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['isRepeatable']) {
    if ((___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['repeatDays']).length != 0) {
      repeatDays = '';
      var day_list = (___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['repeatDays']);
      for (var day_index in day_list) {
        day = day_list[day_index];
        repeatDays = String(repeatDays) + String(String(day) + String(', '));
      }
      content2 = [repeatDays.slice(0, repeatDays.length - 2),' at ',(___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['time'])].join('');
    } else {
      content2 = '';
    }
  } else {
    if (___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['startDate']) {
      content2 = (await BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae']((___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['startDate'])));
    } else {
      content2 = '';
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile/components/e60ff5a294923caa0ad29d11b4c4d69d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('89ac284e5263526174f330a8f0ad26fc')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectCompanies, listSelectAuthor, users, item, project;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Project has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', null));
    ___arguments.context.pageData['tasks'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', null));
    var project_list = (___arguments.context.pageData['tableList']);
    for (var project_index in project_list) {
      project = project_list[project_index];
      if (project['company']) {
        project['company'] = ((await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(project['company'])], false, 'name'))[0]);
      }
    }
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('18bd8823c4a6ebb21717ae25403fb639'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    listSelectAuthor = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'Select author'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3671369989949a060fd5eb99e3b8d52a')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('3671369989949a060fd5eb99e3b8d52a', listSelectAuthor);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', ((listSelectAuthor[0])['value']));
    }
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\'')), 'name', null, 'Select company'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('51d1ae7f7fd9910908a681d852c616cd')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('51d1ae7f7fd9910908a681d852c616cd', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', ((listSelectCompanies[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/projects/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var avatarContent, objectWithAvatar;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatar']) {
      avatarContent = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarContent']);
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatarBgColor']);
    } else {
      avatarContent = null;
    }
  } else {
    avatarContent = null;
  }

  return avatarContent

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['avatar']) {
      visible = true;
    } else {
      visible = false;
    }
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/projects/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['author']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectAuthor']) == ((item['author'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectBillingType']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['billingType']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectBillingType']).toLowerCase() == (item['billingType']).toLowerCase()) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['company']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) == ((item['company'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['title']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51d1ae7f7fd9910908a681d852c616cd', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('3671369989949a060fd5eb99e3b8d52a', 'none');
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4e9946bb0ca533cd316164dfe411ea36'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Project').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'The project has been successfully deleted';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('4e9946bb0ca533cd316164dfe411ea36'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['title LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectBillingType']) != 'none') {
    addItemToList(whereClauseList, (['billingType LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectBillingType']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']) != 'none') {
    addItemToList(whereClauseList, (['company.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']) != 'none') {
    addItemToList(whereClauseList, (['author.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectAuthor']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Project'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)))

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/543699dd05a30bd9e419e42cbd9d9c03/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var progress, projectTasks, resolvedTasks, projectTask, result, task;


  projectTasks = (await (async () => {
    async function callback (task) {
        if (task['project']) {
      result = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']) == ((task['project'])['objectId']);
    } else {
      result = false;
    }


      return result;
    }

    const list = await Promise.all((___arguments.context.pageData['tasks']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  if (projectTasks.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('543699dd05a30bd9e419e42cbd9d9c03'))['width'] = 0;
  } else {
    resolvedTasks = (await (async () => {
      async function callback (projectTask) {


        return ((projectTask['status']) == 'resolved');
      }

      const list = await Promise.all(projectTasks.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('543699dd05a30bd9e419e42cbd9d9c03'))['width'] = (String(progress) + String('%'));
  }

  return ''

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects/components/5435c8b2142e3ecabfa333a2274b1c31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('632df21bc52bdceff8b907095f1cf3dc'))['display'] = 'flex';
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await Backendless.Request.get(`${Backendless.appPath}/services/createPDF/createProjectInvoice`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'id': JSON.stringify((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId'])) }).send()), true, null);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('632df21bc52bdceff8b907095f1cf3dc'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5435c8b2142e3ecabfa333a2274b1c31'))['display'] = 'flex';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/651e01c49a0d523bdea82865acff27b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var tooltipContent, progress, projectTasks, resolvedTasks, projectTask, result, task;


  projectTasks = (await (async () => {
    async function callback (task) {
        if (task['project']) {
      result = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']) == ((task['project'])['objectId']);
    } else {
      result = false;
    }


      return result;
    }

    const list = await Promise.all((___arguments.context.pageData['tasks']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  if (projectTasks.length == 0) {
    tooltipContent = String(0) + String('% done');
  } else {
    resolvedTasks = (await (async () => {
      async function callback (projectTask) {


        return ((projectTask['status']) == 'resolved');
      }

      const list = await Promise.all(projectTasks.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    progress = resolvedTasks.length / projectTasks.length;
    progress = progress * 100;
    tooltipContent = String(Math.round(progress)) + String('% done');
  }

  return tooltipContent

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projects/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companyPage', ({ 'id': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['objectId']),'name': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']) }));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projects/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var tags, emptyCustomList, tag, tagTableItem, tableItem, listSelectCompanies;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', null)), 'name', null, 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('0e8461e95aec06638ee2207880a16b1e', listSelectCompanies);
    emptyCustomList = [({ 'key': '','value': '' })];
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      if ((tableItem['files']) != null) {
        ___arguments.context.pageData['files'] = (tableItem['files']);
      } else {
        ___arguments.context.pageData['files'] = [];
      }
      ___arguments.context.pageData['pageTitle'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['title'] = (tableItem['title']);
      if ((tableItem['company']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('0e8461e95aec06638ee2207880a16b1e', ((tableItem['company'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('0e8461e95aec06638ee2207880a16b1e', 'none');
      }
      if (tableItem['billingType']) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('ed6d002ec0b8e44d516d320b3f1e7a56', ((tableItem['billingType']).toLowerCase()));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('ed6d002ec0b8e44d516d320b3f1e7a56', 'fixed');
      }
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['price'] = (tableItem['billingRateOrPrice']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['currencyCode'] = (tableItem['currencyCode']);
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Project';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('0e8461e95aec06638ee2207880a16b1e', 'none');
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      ___arguments.context.pageData['files'] = [];
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectsUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, valid;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  valid = true;
  if (!(___arguments.context.dataModel['currencyCode'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa4adcb4b4f5a69286afe248a758e182', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('430a7816d7faf9b3d6a3776dfd17c6c5')));
    valid = false;
  }
  if (!(___arguments.context.dataModel['price'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7847b1a7885fb38ef42f42328d954ccf', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('23dca94eaa3e1ff6c88cfbcff624edcc')));
    valid = false;
  }
  if ((___arguments.context.dataModel['price']) > 10000000000000) {
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('23dca94eaa3e1ff6c88cfbcff624edcc')));
    valid = false;
  }
  if ((___arguments.context.dataModel['company']) == 'none') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c23d77e14609208a5495c709fa872b8e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('ea3f6035806cd361bd23fa08ae99e9af')));
    valid = false;
  }
  if (!(___arguments.context.dataModel['title'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f91030ed7374f91b2b4ba31d3e7f20d')));
    valid = false;
  }
  if (!valid) {
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    savedObject = (await Backendless.Data.of('Project').save( ({ 'objectId': (___arguments.context.pageData['id']),'title': (___arguments.context.dataModel['title']),'files': (___arguments.context.pageData['files']),'billingType': (___arguments.context.dataModel['billingType']),'billingRateOrPrice': (___arguments.context.dataModel['price']),'currencyCode': (___arguments.context.dataModel['currencyCode']),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    await Backendless.Data.of('Project').setRelation((___arguments.context.pageData['id']), 'company', (['objectId=\'',(___arguments.context.dataModel['company']),'\''].join('')));
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Project').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    if ((await Backendless.UserService.getCurrentUser(false)) != null) {
      await Backendless.Data.of('Project').setRelation((___arguments.context.pageData['id']), 'author', (['objectId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join('')));
    }
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/projectsUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/da640e9cc87538a7d3dba007e70acf74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/projectsUpdate/components/4f7c2e2bb5af620fba7c20473835d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    var canUpload;


  canUpload = true;
  if (((___arguments.files[0])['size']) > 2097152) {
    canUpload = false;
    throw (new Error('Unable to upnload. The maximum file size is 2Mb.'))
  } else {
    ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['uploadMessage'] = 'Uploading...';
  }

  return canUpload

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['uploadMessage'] = (___arguments.error['message']);

  },  
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['uploadMessage'] = 'File uploaded!';
  ___arguments.context.pageData['files'] = (addItemToList((___arguments.context.pageData['files']), ___arguments.uploadedFiles));

  },  
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/projectsUpdate/components/2f91030ed7374f91b2b4ba31d3e7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da640e9cc87538a7d3dba007e70acf74')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/23dca94eaa3e1ff6c88cfbcff624edcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9604f4eceb9e4bbfcf079f6d3ba6aaf8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/430a7816d7faf9b3d6a3776dfd17c6c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('306b2e2a38c5e2a6752b300875e4bbd8')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/9604f4eceb9e4bbfcf079f6d3ba6aaf8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7847b1a7885fb38ef42f42328d954ccf', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7847b1a7885fb38ef42f42328d954ccf', false);
  }
  if (___arguments.value > 10000000000000) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5ac2d91442727f4d0e397c2d77110c5b', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5ac2d91442727f4d0e397c2d77110c5b', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/projectsUpdate/components/0e8461e95aec06638ee2207880a16b1e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value == 'none') {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c23d77e14609208a5495c709fa872b8e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c23d77e14609208a5495c709fa872b8e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/projectsUpdate/components/306b2e2a38c5e2a6752b300875e4bbd8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa4adcb4b4f5a69286afe248a758e182', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa4adcb4b4f5a69286afe248a758e182', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/projectsUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/projectsUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/resetClientPass/components/05e1c38560e2f59ff4c54f897001f3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var companiesEmails, company, companyId, email, error, isCustomer, response;


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('358d38325d6795730e542a575bc214a7', true);
  try {
    response = (JSON.parse((await Backendless.Request.get(`${Backendless.appPath}/services/resetPassword/resetCustomerPassword`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'emailData': JSON.stringify(((___arguments.context.dataModel['userName']).toLowerCase().trim())) }).send())));
    if (response['result']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9ba272df820142c3826d3774fb07a046'))['background'] = '#4CAF50';
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9ba272df820142c3826d3774fb07a046'))['background'] = 'red';
    }
    ___arguments.context.pageData['message'] = (response['message']);

  } catch (error) {
    ___arguments.context.pageData['message'] = (error['message']);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9ba272df820142c3826d3774fb07a046'))['background'] = 'red';

  } finally {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('358d38325d6795730e542a575bc214a7', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', true);
    ___arguments.context.dataModel['userName'] = '';

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/resetClientPass/components/c751b4a53d646cbef7feeabe3ce31339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/resetClientPass/components/9f1c5a26dfee724d45ea7eaf1045ffc6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aff5e228063a7ec853486f7c9efb9b42')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/resetClientPass/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      await (async function() {
  	const inputs = document.getElementsByTagName('Input');
  	for (let input of inputs) {
  	  input.setAttribute('maxlength', '150');
  	}

  })();

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/resetPassword/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) != null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);
  } else {
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/resetPassword/components/05e1c38560e2f59ff4c54f897001f3c5/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error;


  try {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('358d38325d6795730e542a575bc214a7', true);
    await Backendless.UserService.restorePassword((___arguments.context.dataModel['userName']));
    ___arguments.context.pageData['message'] = 'The password has been sent to your email';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9ba272df820142c3826d3774fb07a046'))['background'] = '#4CAF50';

  } catch (error) {
    ___arguments.context.pageData['message'] = (error['message']);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('9ba272df820142c3826d3774fb07a046'))['background'] = 'red';

  } finally {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('358d38325d6795730e542a575bc214a7', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', true);
    ___arguments.context.dataModel['userName'] = '';

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/resetPassword/components/c751b4a53d646cbef7feeabe3ce31339/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9ba272df820142c3826d3774fb07a046', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/resetPassword/components/9f1c5a26dfee724d45ea7eaf1045ffc6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('aff5e228063a7ec853486f7c9efb9b42')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectPerson, users, item, listSelectProjects, task;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Task has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['tableList'] = (await Backendless.Data.of('Task').find(Backendless.DataQueryBuilder.create().setRelationsDepth(1).setSortBy('dueDateTime').setPageSize(100)));
    var task_list = (___arguments.context.pageData['tableList']);
    for (var task_index in task_list) {
      task = task_list[task_index];
      if (task['assignTo']) {
        task['assignTo'] = ((await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(task['assignTo'])], true, null))[0]);
        if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == ((task['assignTo'])['objectId'])) {
          if ((task['assignTo'])['lastName']) {
            (task['assignTo'])['lastName'] = (String((task['assignTo'])['lastName']) + String(' (You)'));
          } else {
            (task['assignTo'])['lastName'] = ' (You)';
          }
        }
      }
    }
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('da5c45b1328916ad8dfe1987178f56bd'))['display'] = 'none';
    }
    listSelectProjects = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', null)), 'title', null, 'Select project'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5fed8eb2c0334bbe036e66c0d1d10a5')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d5fed8eb2c0334bbe036e66c0d1d10a5', listSelectProjects);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', ((listSelectProjects[0])['value']));
    }
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    listSelectPerson = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'Select colleague'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7a2363128805f188c5c7564cc5749279')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('7a2363128805f188c5c7564cc5749279', listSelectPerson);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('7a2363128805f188c5c7564cc5749279', ((listSelectPerson[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/tasks/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item;


  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['status']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectStatus']).toLowerCase() == (item['status']).toLowerCase()) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectProject']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['project']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectProject']) == ((item['project'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectColleague']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['assignTo']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectColleague']) == ((item['assignTo'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['title']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['title']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('75e2bbf8c472bd97bdb36ee7bab6a061', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('7a2363128805f188c5c7564cc5749279', 'none');
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3215c925325398b6fa433e217e729eb5'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Task').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'Task has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('3215c925325398b6fa433e217e729eb5'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i, timeForFilter, timeAfterMidnight;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['title LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']) != 'none') {
    addItemToList(whereClauseList, (['status LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectStatus']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectProject']) != 'none') {
    addItemToList(whereClauseList, (['project.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectProject']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectColleague']) != 'none') {
    addItemToList(whereClauseList, (['assignTo.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectColleague']),'\''].join('')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Task'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)))

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/1f0121c22e731301849d98eaf3cf88b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo']) {
    content2 = [((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['firstName']),' ',((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['lastName'])].join('');
  } else {
    content2 = '';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tasks/components/5fde689f725359ac50413c548022722a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var avatarContent;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['avatar']) {
      avatarContent = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['avatarContent']);
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fde689f725359ac50413c548022722a'))['background'] = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['avatarBgColor']);
    } else {
      avatarContent = null;
    }
  } else {
    avatarContent = null;
  }

  return avatarContent

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['avatar']) {
      visible = true;
    } else {
      visible = false;
    }
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/tasks/components/a9b95542308d053f94ff1dfec45b51b6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var imageURL;


  imageURL = null;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['image']) {
      imageURL = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignTo'])['image']);
    }
  }

  return imageURL

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/tasks/components/85e453d2c8a4df96dc014e37476d7ae7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projectsUpdate', ({ 'id': ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['project'])['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['project']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['project'])['title']);
  } else {
    content2 = '';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tasks/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/8dd780ca653f0ecb8f1b552300d6e965/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var result;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['dueDateTime']) {
    result = (await BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae']((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['dueDateTime'])));
  } else {
    result = '-';
  }

  return result

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/tasks/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasks/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectProjects, projects, listSelectAssignTo, users, tags, emptyTimeTrackingList, emptyCustomList, tableItem, tag, tagTableItem, item, weekday;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d79db9c824a3dbcdf1fc964e9ef1de2e'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Select time';
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('627b66feb7e990bc9bc8ec3e566ac863'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Datetime';
    emptyCustomList = [({ 'key': '','value': '' })];
    emptyTimeTrackingList = [({ 'task': '','hours': '' })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Task', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      if (tableItem['status']) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', ((tableItem['status']).toLowerCase()));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'open');
      }
      ___arguments.context.pageData['pageTitle'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['title'] = (tableItem['title']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['description'] = (tableItem['description']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['dueDateTime'] = (tableItem['dueDateTime']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['isRepeatable'] = (tableItem['isRepeatable']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['time'] = (tableItem['time']);
      var weekday_list = (tableItem['repeatDays']);
      for (var weekday_index in weekday_list) {
        weekday = weekday_list[weekday_index];
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))[(weekday.toLowerCase())] = true;
      }
      if ((tableItem['timeTracking']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', emptyTimeTrackingList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', (tableItem['timeTracking']));
      }
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = 'Task';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
    }
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    projects = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Project', null));
    if (___arguments.context.pageData['update']) {
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      listSelectAssignTo = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('31a11632da09b4cf714999e6a75bd492', listSelectAssignTo);
      if ((tableItem['assignTo']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', ((tableItem['assignTo'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', 'none');
      }
      listSelectProjects = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](projects, 'title', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectProjects);
      if ((tableItem['project']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', ((tableItem['project'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      }
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', emptyTimeTrackingList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d577214ee8678185f76c9f0b43c41a47', 'open');
      listSelectAssignTo = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('31a11632da09b4cf714999e6a75bd492', listSelectAssignTo);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', 'none');
      listSelectProjects = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](projects, 'title', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectProjects);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/tasksUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, repeatDays, time, minutes, hours;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(___arguments.context.dataModel['title'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2f91030ed7374f91b2b4ba31d3e7f20d')));
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    if (___arguments.context.dataModel['isRepeatable']) {
      repeatDays = [];
      if (___arguments.context.dataModel['monday']) {
        addItemToList(repeatDays, 'Monday');
      }
      if (___arguments.context.dataModel['tuesday']) {
        addItemToList(repeatDays, 'Tuesday');
      }
      if (___arguments.context.dataModel['wednesday']) {
        addItemToList(repeatDays, 'Wednesday');
      }
      if (___arguments.context.dataModel['thursday']) {
        addItemToList(repeatDays, 'Thursday');
      }
      if (___arguments.context.dataModel['friday']) {
        addItemToList(repeatDays, 'Friday');
      }
      if (___arguments.context.dataModel['saturday']) {
        addItemToList(repeatDays, 'Saturday');
      }
      if (___arguments.context.dataModel['sunday']) {
        addItemToList(repeatDays, 'Sunday');
      }
      if (___arguments.context.pageData['timeChange']) {
        if ((___arguments.context.dataModel['time']) == null) {
          time = null;
        } else {
          if ((new Date((___arguments.context.dataModel['time'])).getHours()) < 10) {
            hours = String('0') + String(new Date((___arguments.context.dataModel['time'])).getHours());
          } else {
            hours = (new Date((___arguments.context.dataModel['time'])).getHours());
          }
          if ((new Date((___arguments.context.dataModel['time'])).getMinutes()) < 10) {
            minutes = String('0') + String(new Date((___arguments.context.dataModel['time'])).getMinutes());
          } else {
            minutes = (new Date((___arguments.context.dataModel['time'])).getMinutes());
          }
          time = [hours,':',minutes].join('');
        }
      } else {
        time = (___arguments.context.dataModel['time']);
      }
      savedObject = (await Backendless.Data.of('Task').save( ({ 'objectId': (___arguments.context.pageData['id']),'status': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('d577214ee8678185f76c9f0b43c41a47')),'title': (___arguments.context.dataModel['title']),'description': (___arguments.context.dataModel['description']),'dueDateTime': null,'isRepeatable': (___arguments.context.dataModel['isRepeatable']),'time': time,'repeatDays': repeatDays,'timeTracking': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    } else {
      savedObject = (await Backendless.Data.of('Task').save( ({ 'objectId': (___arguments.context.pageData['id']),'status': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).value })('d577214ee8678185f76c9f0b43c41a47')),'title': (___arguments.context.dataModel['title']),'description': (___arguments.context.dataModel['description']),'dueDateTime': (___arguments.context.dataModel['dueDateTime']),'isRepeatable': (___arguments.context.dataModel['isRepeatable']),'time': null,'repeatDays': null,'timeTracking': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')),'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    }
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    await Backendless.Data.of('Task').setRelation((___arguments.context.pageData['id']), 'assignTo', (['objectId=\'',(___arguments.context.dataModel['assignTo']),'\''].join('')));
    await Backendless.Data.of('Task').setRelation((___arguments.context.pageData['id']), 'project', (['objectId=\'',(___arguments.context.dataModel['project']),'\''].join('')));
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Task').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/tasksUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasksUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/76c41682943fc6bfdda721aba01cb9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['timeChange'] = true;

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/tasksUpdate/components/58ea59b4767cf119e6426a399e84d8ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).push(({ 'task': '','hours': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/d53995a366b7d9cd5ae72b5be04db67b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('ba5c0979ce1b5571ccd7f2fea78d7d4f'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8048d091418f13fad34693038aecfeac')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8048d091418f13fad34693038aecfeac', [({ 'task': '','hours': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/da640e9cc87538a7d3dba007e70acf74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8090bd37e55f9df3a5b182166aa8e0e', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/tasksUpdate/components/2f91030ed7374f91b2b4ba31d3e7f20d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('da640e9cc87538a7d3dba007e70acf74')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/8f0e1d7c349ca54bae26197236d5892c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('17fd5723774fdf54663f2ff8d6def252')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/ca2c2cefaa2746d9feb43f4f3f4a6636/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eda670f84dd893c93cb7179cc34e13c5')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/tasksUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectPerson, listSelectCompanies, touchpoint;


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d5e7e768de4f7cbdfd7e21bde216128f'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('923c9db2bcee54ef444f3ef34ca1c3e1'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Start date';
    if ((function(){ try { return JSON.parse(localStorage.getItem('saved')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = 'Touchpoint has been successfully saved.';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('saved');
    }
    if ((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()) {
      ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String((function(){ try { return JSON.parse(localStorage.getItem('savedError')) } catch(e){ return null }})()));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
      localStorage.removeItem('savedError');
    }
    ___arguments.context.pageData['ourCompany'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Supplier', null));
    ___arguments.context.pageData['tableList'] = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Touchpoint', null));
    var touchpoint_list = (___arguments.context.pageData['tableList']);
    for (var touchpoint_index in touchpoint_list) {
      touchpoint = touchpoint_list[touchpoint_index];
      if (touchpoint['assignedTo']) {
        touchpoint['assignedTo'] = ((await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(touchpoint['assignedTo'])], true, null))[0]);
        if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == ((touchpoint['assignedTo'])['objectId'])) {
          if ((touchpoint['assignedTo'])['lastName']) {
            (touchpoint['assignedTo'])['lastName'] = (String((touchpoint['assignedTo'])['lastName']) + String(' (You)'));
          } else {
            (touchpoint['assignedTo'])['lastName'] = ' (You)';
          }
        }
      }
    }
    ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d8abbded8b05840a591ec1c22eee5f8c')) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5e7e768de4f7cbdfd7e21bde216128f')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d5e7e768de4f7cbdfd7e21bde216128f'))['display'] = 'none';
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('117a0848685692a4a5712c4b6b791741')) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
    }
    listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\'')), 'name', null, 'Select company'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('75e2bbf8c472bd97bdb36ee7bab6a061')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('75e2bbf8c472bd97bdb36ee7bab6a061', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('75e2bbf8c472bd97bdb36ee7bab6a061', ((listSelectCompanies[0])['value']));
    }
    listSelectPerson = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('ClientEmployee', null)), 'firstName', 'lastName', 'Select person'));
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d5fed8eb2c0334bbe036e66c0d1d10a5')) {
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('d5fed8eb2c0334bbe036e66c0d1d10a5', listSelectPerson);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', ((listSelectPerson[0])['value']));
    }
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/touchpoints/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/5af613a4e3e6d045776b8af869657d39/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c7e4a992894b71e5827222e55d261a87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/0464956d3811b26c289231ffe12396c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'id': (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['objectId']),'update': true }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/0cbe033629343dc1846f253a6e27b50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var content2, objectWithAvatar;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    if (!((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['image'])) {
      objectWithAvatar = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])], true, null))[0];
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (objectWithAvatar['avatarBgColor']);
      content2 = (objectWithAvatar['avatarContent']);
    }
  } else {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      objectWithAvatar = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']([(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])], false, 'name'))[0];
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (objectWithAvatar['avatarBgColor']);
      content2 = (objectWithAvatar['avatarContent']);
    } else {
      objectWithAvatar = (await BackendlessUI.Functions.Custom['fn_1bdd050bbb88befbadc32c79892f5a12']((___arguments.context.pageData['ourCompany']), false, 'name'))[0];
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0cbe033629343dc1846f253a6e27b50d'))['background'] = (objectWithAvatar['avatarBgColor']);
      content2 = (objectWithAvatar['avatarContent']);
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var showAvatar;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    if (!((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['image'])) {
      showAvatar = true;
    } else {
      showAvatar = false;
    }
  } else {
    showAvatar = true;
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']) {
        showAvatar = false;
      }
    }
  }

  return showAvatar

  },  
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classList;


  if (!(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])) {
    classList = ['table__avatar', 'table__avatar--square'];
  } else {
    classList = ['table__avatar'];
  }

  return classList

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/touchpoints/components/c6fd264f9c379605f6b8c53d19b536f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var filteredList, result, item, timeForFilter, timeAfterMidnight;


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '0.3';
  ___arguments.context.pageData['startsFilterActive'] = false;
  filteredList = (___arguments.context.pageData['tableList']);
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['company']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectCompany']) == ((item['company'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectPerson']) != 'none') {
    filteredList = (await (async () => {
      async function callback (item) {
          if ((item['client']) != null) {
        if ((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['selectPerson']) == ((item['client'])['objectId'])) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay']) {
    timeAfterMidnight = (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'])).getHours()) * 3600000 + (new Date((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'])).getMinutes()) * 60000;
    timeForFilter = (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay']) - timeAfterMidnight;
    filteredList = (await (async () => {
      async function callback (item) {
          if (item['startDate']) {
        if ((item['startDate']) >= timeForFilter) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']) {
    filteredList = (await (async () => {
      async function callback (item) {
          if (((item['name']).toLowerCase()).indexOf(((___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword']).toLowerCase())) !== -1) {
        result = true;
      } else {
        result = false;
      }


        return result;
      }

      const list = await Promise.all(filteredList.map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
  }
  if (filteredList.length == 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'none';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  }
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', filteredList);
  ___arguments.context.pageData['itemsCount'] = (filteredList.length);
  ___arguments.context.pageData['tableListFiltered'] = filteredList;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/b73fc55b8f36071dbbe42ab9ebb6540e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '0.3';
  ___arguments.context.pageData['startsFilterActive'] = false;
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/d05857d12aed63bd10d95fb796e31f12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '0.3';
  ___arguments.context.pageData['startsFilterActive'] = false;
  ___arguments.context.pageData['tableListFiltered'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
  ___arguments.context.pageData['tableList'] = (await (async () => {
    async function callback (item) {


      return ((item['name']).toLowerCase());
    }

    const list = await Promise.all((___arguments.context.pageData['tableList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/3994337ffe24bfe4803a0b9bf6181d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['startDay'] = null;
  ___arguments.context.pageData['startsFilterActive'] = false;
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('75e2bbf8c472bd97bdb36ee7bab6a061', 'none');
  ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('d5fed8eb2c0334bbe036e66c0d1d10a5', 'none');
  ___arguments.context.getComponentDataStoreByUid('af13e93db6f259f866c7f69e86d6c7a1')['inputKeyword'] = '';
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableList']));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ef8e21e3bc77c4834c7c62e90d040253', false);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('117a0848685692a4a5712c4b6b791741'))['display'] = 'flex';
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableList']).length);
  ___arguments.context.pageData['tableListFiltered'] = (___arguments.context.pageData['tableList']);
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '0.3';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/f25749a34d15ba9a44e9619480880f2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'update': false }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/2a1e7c4e391b0d4bbf2bc9b86adac039/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'none';

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/f798ad9d9228561f53ddc4eb88fd7e75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var currentItem, error, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = ___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931');
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'none';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8dc868e287ed21f5667e5003d50ebc37'))['display'] = 'block';
  try {
    ___arguments.context.pageData['tableListFiltered'] = (await asyncListFilter((___arguments.context.pageData['tableListFiltered']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    ___arguments.context.pageData['tableList'] = (await asyncListFilter((___arguments.context.pageData['tableList']), async (item) => {


     return ((item['objectId']) != (currentItem['objectId']));
    }));
    await Backendless.Data.of('Touchpoint').remove( currentItem );
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['tableListFiltered']));
    ___arguments.context.pageData['alertMessage'] = 'Touchpoint has been successfully deleted.';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = '#4CAF50';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['tableListFiltered']).length);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } catch (error) {
    ___arguments.context.pageData['alertMessage'] = (String('Something went wrong. Server returned: ') + String(error));
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('016acfa150ff21a70317e7ebbc7bbfeb'))['background'] = 'red';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c5ca4224768e6d28e8d93087bd1152f1'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));

  } finally {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('8dc868e287ed21f5667e5003d50ebc37'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('f798ad9d9228561f53ddc4eb88fd7e75'))['display'] = 'block';

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/b6e60a9aa40fd424e50ea8dcc5e744f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var fileURL, whereClose, and, whereClauseList, i, timeForFilter, timeAfterMidnight;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  whereClauseList = [];
  if (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']) {
    addItemToList(whereClauseList, (['name LIKE \'%',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['inputKeyword']),'%\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']) != 'none') {
    addItemToList(whereClauseList, (['company.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectCompany']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectPerson']) != 'none') {
    addItemToList(whereClauseList, (['client.objectId=\'',(((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['selectPerson']),'\''].join('')));
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay']) != null) {
    timeAfterMidnight = (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay'])).getHours()) * 3600000 + (new Date((((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay'])).getMinutes()) * 60000;
    timeForFilter = (((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('af13e93db6f259f866c7f69e86d6c7a1'))['startDay']) - timeAfterMidnight;
    addItemToList(whereClauseList, (String('startDate >=') + String(timeForFilter)));
  }
  if (___arguments.context.pageData['startsFilterActive']) {
    addItemToList(whereClauseList, (String('startDate >= 0')));
  }
  and = ' and ';
  whereClose = '';
  if (whereClauseList != 0) {
    var i_end = whereClauseList.length;
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      whereClose = whereClose + whereClauseList[(i - 1)];
      if (i != whereClauseList.length) {
        whereClose = whereClose + and;
      }
    }
  }
  fileURL = (await Backendless.Request.get(`${Backendless.appPath}/services/saveToCSV/saveToFile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({ 'user-token': Backendless.getCurrentUserToken() })).query({ 'tableName': JSON.stringify('Touchpoint'),'whereClose': JSON.stringify(whereClose) }).send());
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })(fileURL, true, null);
  await Backendless.Files.remove(encodeURI(decodeURI(fileURL)))

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/1f0121c22e731301849d98eaf3cf88b6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo']) {
    content2 = [((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['firstName']),' ',((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['lastName'])].join('');
  } else {
    content2 = '';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/5fde689f725359ac50413c548022722a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var avatarContent, objectWithAvatar;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['avatar']) {
      avatarContent = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['avatarContent']);
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fde689f725359ac50413c548022722a'))['background'] = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['avatarBgColor']);
    }
  } else {
    avatarContent = null;
  }

  return avatarContent

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var avatarContent, visible;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['avatar']) {
      visible = true;
    } else {
      visible = false;
    }
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/touchpoints/components/c8baa97e00f42a4ae11b9623cd0512f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['lastName']);
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c8baa97e00f42a4ae11b9623cd0512f9'))['display'] = 'flex';
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('c8baa97e00f42a4ae11b9623cd0512f9'))['display'] = 'none';
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/7c097804ad996759a9f365412cfcfdbd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['firstName']);
  } else {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['name']);
    } else {
      content2 = 'Internal Meeting';
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/c6ac14e32d64a6d1709fb22899ed827f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2, list;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    content2 = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['position']);
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['company']) {
      content2 = String(content2) + String(String(' at ') + String(((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])['company'])['name']));
    }
  } else {
    if (!(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])) {
      content2 = (((___arguments.context.pageData['ourCompany'])[0])['name']);
    }
  }

  return content2

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/7bd717892482069630b62f8b3b22cd67/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var Starts, i;


  Starts = '';
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['isRepeatable']) {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays']) {
      if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays']).length > 0) {
        var i_end = (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays']).length;
        var i_inc = 1;
        if (1 > i_end) {
          i_inc = -i_inc;
        }
        for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
          if (i == (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays']).length) {
            Starts = String(Starts) + String(String((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays'])[(i - 1)]));
          } else {
            Starts = String(Starts) + String(String((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['repeatDays'])[(i - 1)]) + String(', '));
          }
        }
        Starts = [Starts,' at ',(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['time'])].join('');
      } else {
        if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['time']) {
          Starts = String(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['time']);
        }
      }
    }
  } else {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['startDate']) == null) {
      Starts = null;
    } else {
      Starts = (await BackendlessUI.Functions.Custom['fn_751e827d97ea2b65bb8ae2fdc6c986ae']((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['startDate'])));
    }
  }

  return Starts

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/55d14b74f3d87618e96ac939717b1b6c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client']) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/touchpoints/components/44ac304d81d18c1746fdeb5654217bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '1';
  ___arguments.context.pageData['startsFilterActive'] = true;
  ___arguments.context.pageData['startsListSorted'] = (await (async () => {
    async function callback (item) {


      return (item['startDate']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  ___arguments.context.pageData['startsListSorted'] = (await (async () => {
    async function callback (item) {


      return (item['startDate']);
    }

    const list = await Promise.all((___arguments.context.pageData['startsListSorted']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, 1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['startsListSorted']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['startsListSorted']).length);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/bb9cc76ce1b6753c2d9b4af9ab380269/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}


  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d05857d12aed63bd10d95fb796e31f12'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b73fc55b8f36071dbbe42ab9ebb6540e'))['opacity'] = '0.3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['color'] = '#323232';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('bb9cc76ce1b6753c2d9b4af9ab380269'))['opacity'] = '1';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['color'] = '#0f8be3';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('44ac304d81d18c1746fdeb5654217bd8'))['opacity'] = '0.3';
  ___arguments.context.pageData['startsFilterActive'] = true;
  ___arguments.context.pageData['startsListSorted'] = (await (async () => {
    async function callback (item) {


      return (item['startDate']);
    }

    const list = await Promise.all((___arguments.context.pageData['tableListFiltered']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })());
  ___arguments.context.pageData['startsListSorted'] = (await (async () => {
    async function callback (item) {


      return (item['startDate']);
    }

    const list = await Promise.all((___arguments.context.pageData['startsListSorted']).map(async source => ({
      source,
      value: await callback(source),
    })));

    sortBy(list, -1);

    return list.map(item => item.source)
  })());
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8abbded8b05840a591ec1c22eee5f8c', (___arguments.context.pageData['startsListSorted']));
  ___arguments.context.pageData['itemsCount'] = ((___arguments.context.pageData['startsListSorted']).length);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/a9b95542308d053f94ff1dfec45b51b6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var imageURL;


  imageURL = null;
  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo']) {
    if ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['image']) {
      imageURL = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['assignedTo'])['image']);
    }
  }

  return imageURL

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/touchpoints/components/f60e28c2763a40b99f2ceec24c522149/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var contentType;


  if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['type']) {
    contentType = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['type'])['type']);
  } else {
    contentType = null;
  }

  return contentType

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/touchpoints/components/9912fe65bf8bac9d0098d5bfc75205be/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var url, visible;


  if (!(___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['client'])) {
    if (___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company']) {
      url = ((___arguments.context.getComponentDataStoreByUid('42cc3c19e49bdccfb6bd69a845a6b931')['company'])['image']);
    } else {
      url = null;
    }
  } else {
    url = null;
  }

  return url

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/touchpoints/components/98644ee7ff0599cb7557b6a2b998438d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/e6a23a418431567b3dfe35a7612ddd69/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpoints/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var listSelectTouchpointType, touchpointTypes, listSelectEmplyees, employees, listSelectCompanies, companies, listSelectAssignTo, users, tags, emptyCustomList, tableItem, filteredEmployees, currentCompany, item, tag, tagTableItem, weekday;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'flex';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b')));
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b76df7c967bde654ab41ac5511049dcc'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Datetime';
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0512f29c2afa37641f25c2340867903a'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Datetime';
    (((((((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d79db9c824a3dbcdf1fc964e9ef1de2e'))['el'])['children'])[0])['children'])[0])['children'])[0])['placeholder'] = 'Select time';
    emptyCustomList = [({ 'key': '','value': '' })];
    ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['saveBtn'] = 'Save';
    if (___arguments.context.pageData['update']) {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'flex';
      ___arguments.context.pageData['pageStatus'] = 'Update';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Update';
      tableItem = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Touchpoint', (['objectId=\'',(___arguments.context.pageData['id']),'\''].join(''))))[0];
      ___arguments.context.pageData['pageTitle'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['name'] = (tableItem['name']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['description'] = (tableItem['description']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['startDate'] = (tableItem['startDate']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['endDate'] = (tableItem['endDate']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['isRepeatable'] = (tableItem['isRepeatable']);
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))['time'] = (tableItem['time']);
      var weekday_list = (tableItem['repeatDays']);
      for (var weekday_index in weekday_list) {
        weekday = weekday_list[weekday_index];
        ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fb2cf3ad2782351dd5153a872f363658'))[(weekday.toLowerCase())] = true;
      }
      if ((tableItem['customFields']) == null) {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      } else {
        ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (tableItem['customFields']));
      }
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('5fa4cf2955c400654e8f60d8e804e377'))['display'] = 'none';
      ___arguments.context.pageData['pageStatus'] = 'Create New';
      ___arguments.context.pageData['pageTitle'] = ' Touchpoint';
      ___arguments.context.pageData['statusBreadcrumb'] = 'Create';
    }
    tags = (await Backendless.Data.of('Tag').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)));
    companies = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Company', 'archive= \'false\''));
    users = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('Users', null));
    users = (await Promise.all(users.map(async item => {  if (((await Backendless.UserService.getCurrentUser(false))['objectId']) == (item['objectId'])) {
        item['lastName'] = (String(item['lastName']) + String(' (You)'));
      }
    ; return item;})));
    employees = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('ClientEmployee', null));
    ___arguments.context.pageData['employees'] = employees;
    touchpointTypes = (await BackendlessUI.Functions.Custom['fn_28a25e1f0a29acc69de74219ea997b8b']('touchpointType', null));
    if (___arguments.context.pageData['update']) {
      for (var tag_index in tags) {
        tag = tags[tag_index];
        var tagTableItem_list = (tableItem['tags']);
        for (var tagTableItem_index in tagTableItem_list) {
          tagTableItem = tagTableItem_list[tagTableItem_index];
          if ((tag['objectId']) == (tagTableItem['objectId'])) {
            tag['checked'] = true;
          }
        }
      }
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](companies, 'name', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectCompanies);
      if ((tableItem['client']) != null) {
        if ((tableItem['client'])['company']) {
          currentCompany = (((tableItem['client'])['company'])['objectId']);
          ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', currentCompany);
        }
      } else {
        if ((tableItem['company']) != null) {
          currentCompany = ((tableItem['company'])['objectId']);
          ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', currentCompany);
        } else {
          currentCompany = 'none';
          ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
        }
      }
      listSelectAssignTo = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('31a11632da09b4cf714999e6a75bd492', listSelectAssignTo);
      if ((tableItem['assignedTo']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', ((tableItem['assignedTo'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', 'none');
      }
      if (currentCompany != 'none') {
        employees = (await asyncListFilter(employees, async (item) => {
           if (item['company']) {
            filteredEmployees = ((item['company'])['objectId']) == currentCompany;
          } else {
            filteredEmployees = false;
          }


         return filteredEmployees;
        }));
      }
      listSelectEmplyees = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](employees, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('bcb6dfc55c169f08b07eeee90c8a79bd', listSelectEmplyees);
      if ((tableItem['client']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('bcb6dfc55c169f08b07eeee90c8a79bd', ((tableItem['client'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('bcb6dfc55c169f08b07eeee90c8a79bd', 'none');
      }
      listSelectTouchpointType = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](touchpointTypes, 'type', null, 'None'));
      if ((tableItem['type']) != null) {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('eed32012f3e6513a8362db3359f3d6cd', ((tableItem['type'])['objectId']));
      } else {
        ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('eed32012f3e6513a8362db3359f3d6cd', 'none');
      }
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('eed32012f3e6513a8362db3359f3d6cd', listSelectTouchpointType);
    } else {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', emptyCustomList);
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd8b79dfcb6aed87bccf464ef8395de4', tags);
      listSelectAssignTo = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](users, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('31a11632da09b4cf714999e6a75bd492', listSelectAssignTo);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('31a11632da09b4cf714999e6a75bd492', 'none');
      listSelectCompanies = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](companies, 'name', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('fc04379f4ac95e09905c4cb9630a381c', listSelectCompanies);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('fc04379f4ac95e09905c4cb9630a381c', 'none');
      listSelectEmplyees = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](employees, 'firstName', 'lastName', 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('bcb6dfc55c169f08b07eeee90c8a79bd', listSelectEmplyees);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('bcb6dfc55c169f08b07eeee90c8a79bd', 'none');
      listSelectTouchpointType = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](touchpointTypes, 'type', null, 'None'));
      ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('eed32012f3e6513a8362db3359f3d6cd', listSelectTouchpointType);
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('eed32012f3e6513a8362db3359f3d6cd', 'none');
    }
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('43f70cc318ee91233369b621803229a2'))['display'] = 'none';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('a8440079c41ba21f010848a55aa1360b'))['display'] = 'flex';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d03d3d1990d43a03bb26dc3a613b4bed'))['display'] = 'flex';
    await (async function() {
    	const inputs = document.getElementsByTagName('Input');
    	for (let input of inputs) {
    	  input.setAttribute('maxlength', '150');
    	}

    })();
  }

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/touchpointsUpdate/components/24ed72f8d12188f12fdf1fddb4515d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')), 'aside__expand');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/e54517cf95a7993c23dce3df411646b5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3badcfa33cd2dcfa7a6a5a2cc35463fa')).splice(1, 1);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/f9e51fa2bf52d4ceb2921416d4e2499b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/7c888ad94875a4739e5f10797a7585a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('people', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/29480fce2dbc6caba632c53886fc1462/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('companies', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/a326ac537f615d2f8de682d198b1e239/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/143ac1e400ed78e38d910c52b7d6d60c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('estimates', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/ffe561826b48269e8065a97edb36636b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('projects', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/e9c22fd9b2a41cd15a29ddef944f9683/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('tasks', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/22675ed24f266b158875e73b696c1442/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagues', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/4d69272cee4630e1636393c60d05621d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('expenses', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/566cfe33118d993cddfcb08910e21fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('invoices', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/a1fe5dcbff9cb71745b78be579a3e4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leads', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/a4e470511188f033944224d2dc497065/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('customers', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/3a8c4e74640524b466b1b9353f4ab048/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('leadForms', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/bbacac26e242fae63e4929eeb625e8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c20c65ce544a5b81d86a85b3ea0c881f')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/d0160ab596dae4ea60959e014b456ff3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('442bd85af6d95fa411b46cd4c13c9195')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/e78c8918979cfbffc2bd0285ed0f1b1b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.focus() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('d9f1f668bcd5d8e1d1210b0edfa89aac')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/8fa5ee7bee11314bcf198deebee33dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/73ea1f39a75958f33c8429053c2d1737/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/75c5cc43e7484d0ebee5dfe8988d55d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/28faa5ee9d8add16a2cc02df4c1990ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).push(({ 'key': '','value': '' }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/9e8b3274cd792eebf907c21e7d3f95b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var customRecord, result;


  if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).length > 1) {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', (await (async () => {
      async function callback (customRecord) {


        return (customRecord != ___arguments.context.getComponentDataStoreByUid('859ec992ede2f8697f28a55acf56d767'));
      }

      const list = await Promise.all(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()));
  } else {
    ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c51bf655e6cdc3973389cdb5e3b3a19b', [({ 'key': '','value': '' })]);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/fb2cf3ad2782351dd5153a872f363658/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error, checkedTagsList, tag, savedObject, repeatDays, time, minutes, hours;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(___arguments.context.dataModel['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('bbacac26e242fae63e4929eeb625e8d7')));
    return false;
  }
  try {
    ___arguments.context.dataModel['saveBtn'] = 'Saving...';
    if (___arguments.context.dataModel['isRepeatable']) {
      repeatDays = [];
      if (___arguments.context.dataModel['monday']) {
        addItemToList(repeatDays, 'Monday');
      }
      if (___arguments.context.dataModel['tuesday']) {
        addItemToList(repeatDays, 'Tuesday');
      }
      if (___arguments.context.dataModel['wednesday']) {
        addItemToList(repeatDays, 'Wednesday');
      }
      if (___arguments.context.dataModel['thursday']) {
        addItemToList(repeatDays, 'Thursday');
      }
      if (___arguments.context.dataModel['friday']) {
        addItemToList(repeatDays, 'Friday');
      }
      if (___arguments.context.dataModel['saturday']) {
        addItemToList(repeatDays, 'Saturday');
      }
      if (___arguments.context.dataModel['sunday']) {
        addItemToList(repeatDays, 'Sunday');
      }
      if (___arguments.context.pageData['timeChange']) {
        if ((___arguments.context.dataModel['time']) == null) {
          time = null;
        } else {
          if ((new Date((___arguments.context.dataModel['time'])).getHours()) < 10) {
            hours = String('0') + String(new Date((___arguments.context.dataModel['time'])).getHours());
          } else {
            hours = (new Date((___arguments.context.dataModel['time'])).getHours());
          }
          if ((new Date((___arguments.context.dataModel['time'])).getMinutes()) < 10) {
            minutes = String('0') + String(new Date((___arguments.context.dataModel['time'])).getMinutes());
          } else {
            minutes = (new Date((___arguments.context.dataModel['time'])).getMinutes());
          }
          time = [hours,':',minutes].join('');
        }
      } else {
        time = (___arguments.context.dataModel['time']);
      }
      savedObject = (await Backendless.Data.of('Touchpoint').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'description': (___arguments.context.dataModel['description']),'isRepeatable': (___arguments.context.dataModel['isRepeatable']),'time': time,'startDate': null,'endDate': null,'repeatDays': repeatDays,'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    } else {
      savedObject = (await Backendless.Data.of('Touchpoint').save( ({ 'objectId': (___arguments.context.pageData['id']),'name': (___arguments.context.dataModel['name']),'description': (___arguments.context.dataModel['description']),'isRepeatable': (___arguments.context.dataModel['isRepeatable']),'time': null,'startDate': (___arguments.context.dataModel['startDate']),'endDate': (___arguments.context.dataModel['endDate']),'repeatDays': null,'customFields': ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c51bf655e6cdc3973389cdb5e3b3a19b')) }) ));
    }
    ___arguments.context.pageData['id'] = (savedObject['objectId']);
    await Backendless.Data.of('Touchpoint').setRelation((___arguments.context.pageData['id']), 'assignedTo', (['objectId=\'',(___arguments.context.dataModel['assignedTo']),'\''].join('')));
    await Backendless.Data.of('Touchpoint').setRelation((___arguments.context.pageData['id']), 'company', (['objectId=\'',(___arguments.context.dataModel['company']),'\''].join('')));
    await Backendless.Data.of('Touchpoint').setRelation((___arguments.context.pageData['id']), 'client', (['objectId=\'',(___arguments.context.dataModel['person']),'\''].join('')));
    await Backendless.Data.of('Touchpoint').setRelation((___arguments.context.pageData['id']), 'type', (['objectId=\'',(___arguments.context.dataModel['touchpointType']),'\''].join('')));
    checkedTagsList = [];
    var tag_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cd8b79dfcb6aed87bccf464ef8395de4'));
    for (var tag_index in tag_list) {
      tag = tag_list[tag_index];
      if (tag['checked']) {
        addItemToList(checkedTagsList, (tag['objectId']));
      }
    }
    await Backendless.Data.of('Touchpoint').setRelation((___arguments.context.pageData['id']), 'tags', checkedTagsList);
    localStorage.setItem('saved', JSON.stringify(true));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  } catch (error) {
    localStorage.setItem('savedError', JSON.stringify((error['message'])));
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpoints', null);

  }

  },  
  /* handler:onSubmit */
  /* content */
}))

define('./pages/touchpointsUpdate/components/03ce343bcfc5447b957713f3ebbbf2f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('touchpointsUpdate', ({ 'update': false }));
  ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })((await ( async function (){ return window.location.href })()), false, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/c20c65ce544a5b81d86a85b3ea0c881f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['name'])) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', true);
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('411ff2c5c0b567e8a67fd3da9492b1bc', false);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/touchpointsUpdate/components/76c41682943fc6bfdda721aba01cb9c5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['timeChange'] = true;

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/touchpointsUpdate/components/fc04379f4ac95e09905c4cb9630a381c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var employee, employees, isCompanyEmployee, item, listSelectEmplyees, notReset;


  if ((___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['company']) != 'none') {
    employees = (await (async () => {
      async function callback (item) {
          if (item['company']) {
        isCompanyEmployee = ((item['company'])['objectId']) == (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['company']);
      } else {
        isCompanyEmployee = false;
      }


        return isCompanyEmployee;
      }

      const list = await Promise.all((___arguments.context.pageData['employees']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })());
    listSelectEmplyees = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246'](employees, 'firstName', 'lastName', 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('bcb6dfc55c169f08b07eeee90c8a79bd', listSelectEmplyees);
    for (var employee_index in employees) {
      employee = employees[employee_index];
      if ((employee['objectId']) == (___arguments.context.getComponentDataStoreByUid('fb2cf3ad2782351dd5153a872f363658')['person'])) {
        notReset = true;
      }
    }
    if (!notReset) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('bcb6dfc55c169f08b07eeee90c8a79bd', 'none');
    }
  } else {
    listSelectEmplyees = (await BackendlessUI.Functions.Custom['fn_726d45b76f115c38b51560439dfe0246']((___arguments.context.pageData['employees']), 'firstName', 'lastName', 'None'));
    ;(function (componentUid, options){ ___arguments.context.getComponentByUid(componentUid).options = options })('bcb6dfc55c169f08b07eeee90c8a79bd', listSelectEmplyees);
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/touchpointsUpdate/components/add750a988f94bc17107a4b5feae7f35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('clientLogin', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/8a889c8a5f92331ac12e0d78a2447005/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('login', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/3355c875d0f1b6b5993be4bf3ac34413/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('colleagueUpdate', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/5c5eb782d0b9c7a70df4e55ba93b42b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('calendar', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/f86ac286e8f8f2b291d12e55cefde1c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/0659e173d655bd437b5c3c1b8baee6e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('dashboard', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/touchpointsUpdate/components/d14b0c4139dfac1b4e367d0475e509a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://backendless.com', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

